export enum BlockPath {
  FoundationsCompanyName = "company-name",
  FoundationsMonetizationModel = "monetization-model",
  FoundationsOriginStory = "origin-story",
  FoundationsExperienceWebsite = "experience-website",
  CustomerAudienceDescription = "audience-description",
  CustomerAudienceInterests = "audience-interests",
  CustomerIdealCustomer = "ideal-customer",
  CustomerAudienceSegments = "audience-segments",
  BrandBusinessImpact = "business-impact",
  BrandMissionVision = "mission-vision",
  BrandBrandPositioning = "brand-positioning",
  BrandBrandExperiencePrinciples = "brand-experience-principles",
  BrandBrandIdentity = "brand-identity",
  BrandValueProposition = "value-proposition",
  BrandBrandTone = "brand-tone",
  ProductProductList = "product-list",
  ProductProductFeatures = "product-features",
  ProductProductFaq = "product-faq",
  ProductProductCaseStudies = "product-case-studies",
  ProductProductDiscount = "product-discount",
  ProductProductStrategy = "product-strategy",
  ProductProductRoadmap = "product-roadmap",
  MembershipMembershipModel = "membership-model",
  MembershipCommunityStrategy = "community-strategy",
  MembershipMembershipStructure = "membership-structure",
  MembershipMembershipApplicationCriteria = "membership-application-criteria",
  MembershipMemberReferral = "member-referral",
  ExperienceExperienceTechnologyPlatforms = "experience-technology-platforms",
  ExperienceUserOnboarding = "user-onboarding",
  ExperienceCustomerService = "customer-service",
  ContentContentPositioning = "content-positioning",
  ContentContentPrinciples = "content-principles",
  ContentContentPillars = "content-pillars",
  ContentSocialChannels = "social-channels",
  ContentSocialStrategy = "social-strategy",
  ContentContentInfluencer = "content-influencer",
  ContentNewsletterFormat = "newsletter-format",
  ContentContentOutboundEmailApproach = "content-outbound-email-approach",
  ContentContentArticleFormat = "content-article-format",
  ContentContentPressReleaseFormat = "content-press-release-format",
  ContentContentCaseStudy = "content-case-study",
  ContentContentQualityControl = "content-quality-control",
  ContentContentGlossary = "content-glossary",
  ContentContentComplianceRegulations = "content-compliance-regulations",
  CommsAdvertisingNextQuarterGoals = "advertising-next-quarter-goals",
  CommsMarketingGoal = "marketing-goal",
  CommsUserPainpoints = "user-painpoints",
  CommsBarrierAssessment = "barrier-assessment",
  CommsCommunicationGoals = "communication-goals",
  CommsKeyMessages = "key-messages",
  CommsSocialTactics = "social-tactics",
  CommsBrandTaglines = "brand-taglines",
  CommsSocialCampaignChannel = "social-campaign-channel",
  CommsSocialCampaignStrategy = "social-campaign-strategy",
  CommsMarketingBudget = "marketing-budget",
  CommsPaidAdvertising = "paid-advertising",
  CommsGoogleAd = "google-ad",
  OperationsBusinessStaffing = "business-staffing",
  OperationsOperationsLeadershipBios = "operations-leadership-bios",
  OperationsContactDetails = "contact-details",
  OperationsOperationsSocialHandles = "operations-social-handles",
  OperationsCookiePolicy = "cookie-policy",
  OperationsPrivacyPolicy = "privacy-policy",
  GrowthYearGoals = "year-goals",
  GrowthGrowthMarketingObjectives = "growth-marketing-objectives",
  GrowthGrowthOkrs = "growth-okrs",
  GrowthGrowthFiveYear = "growth-five-year",
  GrowthQuarterlyPlanning = "quarterly-planning",
  GrowthQuarterlyPromotion = "quarterly-promotion",
  GrowthGrowthGtmMetrics = "growth-gtm-metrics",
  GrowthGrowthMetrics = "growth-metrics",
  GrowthGrowthCampaignMetrics = "growth-campaign-metrics",
  SalesSalesObjectivesMetrics = "sales-objectives-metrics",
  SalesSalesCustomerProfile = "sales-customer-profile",
  SalesSalesIcpTriggers = "sales-icp-triggers",
  SalesSalesBuyerPersona = "sales-buyer-persona",
  SalesSalesBuyerSegments = "sales-buyer-segments",
  SalesSalesVertical = "sales-vertical",
  SalesSalesPrinciples = "sales-principles",
  SalesSalesProcess = "sales-process",
  SalesOutboundEmailstrategy = "outbound-emailstrategy",
  SalesOutreachSalesstrategy = "outreach-salesstrategy",
  SalesAffiliateSales = "affiliate-sales",
  SalesSalesProposalFormat = "sales-proposal-format",
  PartnershipsMembershipPartnerships = "membership-partnerships",
  PartnershipsPartnershipsCurrent = "partnerships-current",
  PartnershipsPartnershipsAffiliate = "partnerships-affiliate",
  PolicyPolicyAi = "policy-ai",
  PolicyPolicyPrivacy = "policy-privacy",
  PolicyPolicyHr = "policy-hr",
  PolicyPolicyData = "policy-data",
  PolicyPolicyBoardGovernance = "policy-board-governance",
  PolicyPolicyAdvocacy = "policy-advocacy",
  PolicyPolicyBylawsGovernance = "policy-bylaws-governance",
  PolicyPolicyAntiBriberyCorruption = "policy-anti-bribery-corruption",
  PolicyPolicyCodeConduct = "policy-code-conduct",
  PolicyPolicyHsecs = "policy-hsecs",
  PolicyPolicyItAcceptableUsePolicy = "policy-it-acceptable-use-policy",
  PolicyPolicyCrimePreventionPolicy = "policy-crime-prevention-policy",
  HrHrJobdescription = "hr-jobdescription",
  HrHrProcess = "hr-process",
  SustainabilitySustainabilityPolicy = "sustainability-policy",
  SustainabilitySustainabilityGovernance = "sustainability-governance",
  SustainabilitySustainabilityStrategicFrameworkNarrative = "sustainability-strategic-framework-narrative",
  SustainabilitySustainabilityStrategicFrameworkData = "sustainability-strategic-framework-data",
  SustainabilitySustainabilityEconomicContributionNarrative = "sustainability-economic-contribution-narrative",
  SustainabilitySustainabilityEconomicContributionData = "sustainability-economic-contribution-data",
  SustainabilitySustainabilityInnovationNarrative = "sustainability-innovation-narrative",
  SustainabilitySustainabilityInnovationData = "sustainability-innovation-data",
  SustainabilitySustainabilityGovernanceNarrative = "sustainability-governance-narrative",
  SustainabilitySustainabilityGovernanceData = "sustainability-governance-data",
  SustainabilitySustainabilityComplianceNarrative = "sustainability-compliance-narrative",
  SustainabilitySustainabilityComplianceData = "sustainability-compliance-data",
  SustainabilitySustainabilityHumanRightsNarrative = "sustainability-human-rights-narrative",
  SustainabilitySustainabilityHumanRightsData = "sustainability-human-rights-data",
  SustainabilitySustainabilityRiskManagementNarrative = "sustainability-risk-management-narrative",
  SustainabilitySustainabilityCyberSecurityNarrative = "sustainability-cyber-security-narrative",
  SustainabilitySustainabilityCyberSecurityData = "sustainability-cyber-security-data",
  SustainabilitySustainabilityPeopleSocietyNarrative = "sustainability-people-society-narrative",
  SustainabilitySustainabilityPeopleSocietyData = "sustainability-people-society-data",
  SustainabilitySustainabilityHealthSafetyNarrative = "sustainability-health-safety-narrative",
  SustainabilitySustainabilityHealthSafetyData = "sustainability-health-safety-data",
  SustainabilitySustainabilityWorkersNarrative = "sustainability-workers-narrative",
  SustainabilitySustainabilityWorkersData = "sustainability-workers-data",
  SustainabilitySustainabilityCommunitiesNarrative = "sustainability-communities-narrative",
  SustainabilitySustainabilityCommunitiesData = "sustainability-communities-data",
  SustainabilitySustainabilitySuppliersNarrative = "sustainability-suppliers-narrative",
  SustainabilitySustainabilitySuppliersData = "sustainability-suppliers-data",
  SustainabilitySustainabilityEnvironmentNarrative = "sustainability-environment-narrative",
  SustainabilitySustainabilityEnvironmentData = "sustainability-environment-data",
  SustainabilitySustainabilityEnvironmentalManagementNarrative = "sustainability-environmental-management-narrative",
  SustainabilitySustainabilityEnvironmentalManagementData = "sustainability-environmental-management-data",
  SustainabilitySustainabilityClimateChangeNarrative = "sustainability-climate-change-narrative",
  SustainabilitySustainabilityClimateChangeData = "sustainability-climate-change-data",
  SustainabilitySustainabilityEnergyManagementNarrative = "sustainability-energy-management-narrative",
  SustainabilitySustainabilityEnergyManagementData = "sustainability-energy-management-data",
  SustainabilitySustainabilityWaterStewardshipNarrative = "sustainability-water-stewardship-narrative",
  SustainabilitySustainabilityWaterStewardshipData = "sustainability-water-stewardship-data",
  SustainabilitySustainabilityCircularEconomyNarrative = "sustainability-circular-economy-narrative",
  SustainabilitySustainabilityCircularEconomyData = "sustainability-circular-economy-data",
  SustainabilitySustainabilityTailingsNarrative = "sustainability-tailings-narrative",
  SustainabilitySustainabilityTailingsData = "sustainability-tailings-data",
  SustainabilitySustainabilityBiodiversityNarrative = "sustainability-biodiversity-narrative",
  SustainabilitySustainabilityBiodiversityData = "sustainability-biodiversity-data",
  SustainabilitySustainabilityStakeholderEngagementNarrative = "sustainability-stakeholder-engagement-narrative",
  SustainabilitySustainabilityStakeholderEngagementData = "sustainability-stakeholder-engagement-data",
  SponsorshipsSponsorshipTypes = "sponsorship-types",
  SponsorshipsSponsorshipsPackages = "sponsorships-packages",
  SponsorshipsSponsorshipCurrent = "sponsorship-current",
  SponsorshipsSponsorshipCriteria = "sponsorship-criteria",
  PodcastPodcastConceptPositioning = "podcast-concept-positioning",
  PodcastPodcastGoalsKpis = "podcast-goals-kpis",
  PodcastPodcastAudiencePersona = "podcast-audience-persona",
  PodcastPodcastEpisodePlanningStrategy = "podcast-episode-planning-strategy",
  PodcastPodcastGuestDescription = "podcast-guest-description",
  PodcastPodcastDistributionChannels = "podcast-distribution-channels",
  PodcastPodcastBrandingGuidelines = "podcast-branding-guidelines",
  PodcastPodcastMonetizationSponsorship = "podcast-monetization-sponsorship",
  GrantsGrantsMakerProfile = "grants-maker-profile",
  GrantsGrantsImpactPortfolio = "grants-impact-portfolio",
  GrantsGrantsPrograms = "grants-programs",
  GrantsGrantsApplicationProcess = "grants-application-process",
  GrantsGrantsTypeSize = "grants-type-size",
  GrantsGrantsEligibility = "grants-eligibility",
  GrantsGrantsGrantees = "grants-grantees",
  GrantsGrantsLiveProposals = "grants-live-proposals",
  EventsEventsFacilities = "events-facilities",
  EventsEventsPackages = "events-packages",
  EventsEventSponsorshipsPackages = "event-sponsorships-packages",
  EventsEventsFood = "events-food",
  EventsEventsDrinks = "events-drinks",
  EventsEventsTravel = "events-travel",
  EventsEventsOperations = "events-operations",
  DesignerDesignerEthos = "designer-ethos",
  DesignerDesignerCapabilities = "designer-capabilities",
  DesignerDesignerProcess = "designer-process",
  DesignerDesignerProposal = "designer-proposal",
  EducationEducationType = "education-type",
  EducationEducationStudentLevel = "education-student-level",
  EducationEducationClasses = "education-classes",
  EducationEducationFunding = "education-funding",
  EducationEducationFees = "education-fees",
  EducationEducationFacilities = "education-facilities",
  EducationEducationAlumni = "education-alumni",
  EducationEducationExtracurricular = "education-extracurricular",
  StartupStartupProblem = "startup-problem",
  StartupStartupCompanyLocation = "startup-company-location",
  StartupStartupFundraisingStatus = "startup-fundraising-status",
  StartupStartupInvestorProfile = "startup-investor-profile",
  StartupStartupElevatorPitch = "startup-elevator-pitch",
  StartupStartupInvestorUpdate = "startup-investor-update",
  PublisherMediaPublisherMediaCitywire = "publisher-media-citywire",
  PublisherMediaPublisherMediaFuture = "publisher-media-future",
  PublisherMediaPublisherMediaIncisive = "publisher-media-incisive",
  PublisherMediaPublisherMediaTrustnet = "publisher-media-trustnet",
  PublisherMediaPublisherMediaFtadviser = "publisher-media-ftadviser",
  PublisherMediaPublisherMediaFinancialTimes = "publisher-media-financial-times",
  PublisherMediaPublisherMediaTelegraph = "publisher-media-telegraph",
  PublisherMediaPublisherMediaTheTimes = "publisher-media-the-times",
  PublisherMediaPublisherMediaSpectator = "publisher-media-spectator",
  PublisherMediaPublisherMediaNewStatesman = "publisher-media-new-statesman",
  PublisherMediaPublisherMediaGuardian = "publisher-media-guardian",
  PublisherMediaPublisherMediaObserver = "publisher-media-observer",
  PublisherMediaPublisherMediaEconomist = "publisher-media-economist",
  PublisherMediaPublisherMediaPerspectivePublishing = "publisher-media-perspective-publishing",
  PublisherMediaPublisherMediaWealthWise = "publisher-media-wealth-wise",
  PublisherMediaPublisherMediaFundsEurope = "publisher-media-funds-europe",
  PublisherMediaPublisherMediaAssetTv = "publisher-media-asset-tv",
  PublisherMediaPublisherMediaIfaMagazine = "publisher-media-ifa-magazine",
  PublisherMediaPublisherMediaPortfolioAdviser = "publisher-media-portfolio-adviser",
  PublisherMediaPublisherMediaMobkoi = "publisher-media-mobkoi",
  PublisherMediaPublisherMediaSmartology = "publisher-media-smartology",
  PublisherMediaPublisherMediaDianomi = "publisher-media-dianomi",
  PublisherMediaPublisherMediaMorningstar = "publisher-media-morningstar",
  PublisherMediaPublisherMediaTeads = "publisher-media-teads",
  PublisherMediaPublisherMediaSkyAdsmart = "publisher-media-sky-adsmart",
  PublisherMediaPublisherMediaRadioWorks = "publisher-media-radio-works",
  PublisherMediaPublisherMediaQubeOoh = "publisher-media-qube-ooh",
  FarmFarmType = "farm-type",
  FarmFarmSize = "farm-size",
  FarmFarmEnvironmentalprograms = "farm-environmentalprograms",
  FarmCropTypes = "crop-types",
  FarmLivestockTypes = "livestock-types",
  FarmFarmProduce = "farm-produce",
  FarmFarmEquipment = "farm-equipment",
  FarmFarmCultivation = "farm-cultivation",
  FarmFarmProcesses = "farm-processes",
  FarmFarmFieldKnowledge = "farm-field-knowledge",
  EcommEcommShipping = "ecomm-shipping",
  EcommEcommReturnDetails = "ecomm-return-details",
  EcommEcommReturns = "ecomm-returns",
  EfuelsEfuelsFacilitiesOne = "efuels-facilities-one",
  EfuelsEfuelsFacilitiesTwo = "efuels-facilities-two",
  EfuelsEfuelsFacilitiesThree = "efuels-facilities-three",
  EfuelsEfuelsFacilitiesFour = "efuels-facilities-four",
  EfuelsEfuelsFacilitiesFive = "efuels-facilities-five",
  EfuelsEfuelsFacilitiesSix = "efuels-facilities-six",
  EfuelsEfuelsFacilitiesSeven = "efuels-facilities-seven",
  EfuelsEfuelsFacilitiesEight = "efuels-facilities-eight",
  EfuelsEfuelsFacilitiesNine = "efuels-facilities-nine",
  EfuelsEfuelsFacilitiesTen = "efuels-facilities-ten",
  EfuelsEfuelsGlobalGoals = "efuels-global-goals",
  EfuelsEfuelsDirectAirCapture = "efuels-direct-air-capture",
  EfuelsEfuelsModularisation = "efuels-modularisation",
  EfuelsEfuelsAdvocacy = "efuels-advocacy",
  EfuelsEfuelsInternationalPolicy = "efuels-international-policy",
  TravelTravelLocations = "travel-locations",
  TravelTravelAvailability = "travel-availability",
  TravelTravelLocationtimes = "travel-locationtimes",
  TravelTravelReseller = "travel-reseller",
  ConsultingConsultingSpeciality = "consulting-speciality",
  ConsultingDiscoveryApproach = "discovery-approach",
  ConsultingConsultingProcess = "consulting-process",
  ConsultingConsultingProposal = "consulting-proposal",
  ConsultingConsultingHourlyRate = "consulting-hourly-rate",
  ConsultingConsultingInterviewGuide = "consulting-interview-guide",
  ConsultingConsultingKickoffAgenda = "consulting-kickoff-agenda",
  ConsultingConsultingWeeklyMeetingAgenda = "consulting-weekly-meeting-agenda",
  ConsultingConsultingProjectFeedbackAgenda = "consulting-project-feedback-agenda",
  ConsultingConsultingProjectStatus = "consulting-project-status",
  ArchitectArchitectureType = "architecture-type",
  ArchitectArchitectureConstruction = "architecture-construction",
  ArchitectArchitectureServices = "architecture-services",
  ArchitectArchitectureWork = "architecture-work",
  WineWineGrapes = "wine-grapes",
  WineWinePhilosophy = "wine-philosophy",
  WineWineVineyard = "wine-vineyard",
  WineWineTerroir = "wine-terroir",
  WineWineTour = "wine-tour",
  WineRedWineList = "red-wine-list",
  WineWhiteWineList = "white-wine-list",
  WineMiscWineList = "misc-wine-list",
  BeverageBeveragesTypes = "beverages-types",
  BeverageBeverageVarieties = "beverage-varieties",
  BeverageBeverageProduction = "beverage-production",
  BeverageBeverageTasting = "beverage-tasting",
  BeverageBeveragePremises = "beverage-premises",
  BeverageBeverageDistribution = "beverage-distribution",
  AccommodationAccommodationType = "accommodation-type",
  AccommodationAccommodationLocations = "accommodation-locations",
  AccommodationAccommodationDescription = "accommodation-description",
  AccommodationAccommodationPackages = "accommodation-packages",
  AccommodationAccommodationRules = "accommodation-rules",
  AccommodationAccommodationContact = "accommodation-contact",
  SelfStorageStorageType = "storage-type",
  SelfStorageStorageArea = "storage-area",
  SelfStorageStorageRules = "storage-rules",
  SelfStorageStorageRent = "storage-rent",
  SelfStorageStorageSecurity = "storage-security",
  SelfStorageStorageContact = "storage-contact",
  RestaurantRestaurantType = "restaurant-type",
  RestaurantRestaurantMenu = "restaurant-menu",
  RestaurantRestaurantSignatureDish = "restaurant-signature-dish",
  RestaurantRestaurantPriorityDish = "restaurant-priority-dish",
  RestaurantRestaurantCrossSell = "restaurant-cross-sell",
  RestaurantRestaurantMenuPackaging = "restaurant-menu-packaging",
  RealEstateRealEstateType = "real-estate-type",
  RealEstateRealEstateLocations = "real-estate-locations",
  RealEstateRealEstateComplaint = "real-estate-complaint",
  DentistDentistTypes = "dentist-types",
  DentistDentistTeam = "dentist-team",
  DoctorDoctorField = "doctor-field",
  DoctorDoctorTeam = "doctor-team",
  DoctorDoctorQualifications = "doctor-qualifications",
  DoctorDoctorInsurance = "doctor-insurance",
  CharityNonprofitName = "nonprofit-name",
  CharityNonprofitType = "nonprofit-type",
  CharityNonprofitLocations = "nonprofit-locations",
  CharityNonprofitFramework = "nonprofit-framework",
  CharityNonprofitImpactModel = "nonprofit-impact-model",
  CharityNonprofitBeneficiary = "nonprofit-beneficiary",
  CharityNonprofitBeneficiaryGroups = "nonprofit-beneficiary-groups",
  CharityNonprofitMissionObjectives = "nonprofit-mission-objectives",
  CharityNonprofitImpactPrograms = "nonprofit-impact-programs",
  CharityNonprofitMetrics = "nonprofit-metrics",
  CharityNonprofitGovernance = "nonprofit-governance",
  CharityNonprofitPartnerships = "nonprofit-partnerships",
  CharityNonprofitFundMix = "nonprofit-fund-mix",
  CharityNonprofitGrants = "nonprofit-grants",
  CharityNonprofitDonorTypes = "nonprofit-donor-types",
  CharityNonprofitTactics = "nonprofit-tactics",
  AgencyAgencyType = "agency-type",
  AgencyAgencyCapabilities = "agency-capabilities",
  AgencyAgencyProcess = "agency-process",
  AgencyAgencySpeciality = "agency-speciality",
  AgencyAgencyCasestudies = "agency-casestudies",
  AgencyAgencyAwards = "agency-awards",
  AgencyAgencySow = "agency-sow",
  AgencyAgencyRates = "agency-rates",
  AgencyAgencyTestimonials = "agency-testimonials",
  AgencyAgencyLeads = "agency-leads",
  ConstructionConstructionTypes = "construction-types",
  ConstructionConstructionTeam = "construction-team",
  ConstructionConstructionOverhead = "construction-overhead",
  ConstructionConstructionOverheadVariable = "construction-overhead-variable",
  ConstructionConstructionBilling = "construction-billing",
  FundFundName = "fund-name",
  FundFundSize = "fund-size",
  FundFundThesis = "fund-thesis",
  FundFundStage = "fund-stage",
  FundFundDate = "fund-date",
  FundCheckSize = "check-size",
  FundFundProcess = "fund-process",
  FundFundPortfolio = "fund-portfolio",
  ManufacturingManufacturingIndustries = "manufacturing-industries",
  ManufacturingManufacturingSubsidiary = "manufacturing-subsidiary",
  ManufacturingManufacturingProcess = "manufacturing-process",
  ManufacturingManufacturingMaterials = "manufacturing-materials",
  ManufacturingManufacturingSolutions = "manufacturing-solutions",
  CoachCoachType = "coach-type",
  CoachCoachQualifications = "coach-qualifications",
  CoachCoachPhilosophy = "coach-philosophy",
  CoachCoachCourse = "coach-course",
  CoachCoachMethod = "coach-method",
  CoachCoachTechniques = "coach-techniques",
  CoachCoachCaseStudies = "coach-case-studies",
  SportsTeamSportsTeamGround = "sports-team-ground",
  SportsTeamSportsTeamCoaching = "sports-team-coaching",
  SportsTeamSportsTeamPlayers = "sports-team-players",
  SportsTeamSportsTeamFeatures = "sports-team-features",
  SportsTeamSportsTeamSponsors = "sports-team-sponsors",
  PersonalTrainerExerciseTypes = "exercise-types",
  PersonalTrainerExerciseEquipment = "exercise-equipment",
  PersonalTrainerTrainingPhilosophy = "training-philosophy",
  PersonalTrainerDietPhilosophy = "diet-philosophy",
  PersonalTrainerProgramDesign = "program-design",
  PersonalTrainerSuccessStories = "success-stories",
  GymGymOpeningTimes = "gym-opening-times",
  GymGymEquipment = "gym-equipment",
  GymGymClasses = "gym-classes",
  AthleteAthleteSport = "athlete-sport",
  AthleteAthleteSponsors = "athlete-sponsors",
  AthleteAthleteAchievements = "athlete-achievements",
  ClimbingGymClimbingLocations = "climbing-locations",
  ClimbingGymClimbingTypes = "climbing-types",
  ClimbingGymClimbingEthos = "climbing-ethos",
  ClimbingGymClimbingPasses = "climbing-passes",
  ClimbingGymClimbingTraining = "climbing-training",
  ClimbingGymClimbingClasses = "climbing-classes",
  ClimbingGymClimbingSafety = "climbing-safety",
  GolfClubGolfCourse = "golf-course",
  GolfClubGolfEthos = "golf-ethos",
  GolfClubGolfFacilities = "golf-facilities",
  GolfClubGolfCourseGuide = "golf-course-guide",
  GolfClubGolfCompetitions = "golf-competitions",
  GolfClubGolfTeams = "golf-teams",
  LandManagementLandSize = "land-size",
  LandManagementLandType = "land-type",
  LandManagementLandPurpose = "land-purpose",
  LandManagementLandGoals = "land-goals",
  LandManagementLandPolicies = "land-policies",
  LandManagementLandRental = "land-rental",
  LandManagementLandCapital = "land-capital",
  LandManagementLandEnvironmentalStrategy = "land-environmental-strategy",
  LandManagementLandSocial = "land-social",
  LandManagementLandWildlife = "land-wildlife",
  LandManagementLandTeam = "land-team",
  RetailRetailPrinciples = "retail-principles",
  RetailRetailCustomerService = "retail-customer-service",
  RetailRetailSeasonalCampaignBrief = "retail-seasonal-campaign-brief",
  RetailRetailCampaignSignOff = "retail-campaign-sign-off",
  RetailRetailOpeningPlan = "retail-opening-plan",
  RetailRetailWholesale = "retail-wholesale",
  RetailRetailConcessions = "retail-concessions",
  ResearchResearchMarket = "research-market",
  ResearchResearchConsumer = "research-consumer",
  ResearchResearchCompetitor = "research-competitor",
  ResearchResearchAudienceInsights = "research-audience-insights",
  BuildingManagementBuildingAlterationPolicy = "building-alteration-policy",
  BuildingManagementBuildingAlterationApplication = "building-alteration-application",
  BuildingManagementBuildingSubletGuide = "building-sublet-guide",
  BuildingManagementBuildingSubletRider = "building-sublet-rider",
  BuildingManagementBuildingSubletApplication = "building-sublet-application",
  BuildingManagementBuildingDecorationApplication = "building-decoration-application",
  BuildingManagementBuildingSalesPolicy = "building-sales-policy",
  BuildingManagementBuildingSalesApplication = "building-sales-application",
  BuildingManagementBuildingClosingInstructions = "building-closing-instructions",
  BuildingManagementBuildingHowGuide = "building-how-guide",
  BuildingManagementBuildingDuesPayments = "building-dues-payments",
  BuildingManagementBuildingMaintenance = "building-maintenance",
  BuildingManagementTrashManagement = "trash-management",
  BuildingManagementStorageWaivers = "storage-waivers",
  BuildingManagementBuildingMovingPolicy = "building-moving-policy",
  BuildingManagementBuildingHomeowners = "building-homeowners",
  BuildingManagementBuildingRefiProcess = "building-refi-process",
  BuildingManagementBuildingRefiPolicy = "building-refi-policy",
  BuildingManagementBuildingRefiApplication = "building-refi-application",
  BuildingManagementBuildingTrustEstate = "building-trust-estate",
  BuildingManagementBuildingCertificateIncorporation = "building-certificate-incorporation",
  BuildingManagementBuildingDeclarationCondominium = "building-declaration-condominium",
  BuildingManagementBuildingOfferingPlan = "building-offering-plan",
  BuildingManagementBuildingSubscriptionAgreement = "building-subscription-agreement",
  BuildingManagementBuildingBylaws = "building-bylaws",
  BuildingManagementBuildingProprietaryLease = "building-proprietary-lease",
  BuildingManagementBuildingPlans = "building-plans",
  BuildingManagementBuildingHouseRules = "building-house-rules",
  LawyerLawyerServices = "lawyer-services",
  LawyerLawyerClients = "lawyer-clients",
  MiningMiningOperationOne = "mining-operation-one",
  MiningMiningOperationTwo = "mining-operation-two",
  MiningMiningOperationThree = "mining-operation-three",
  MiningMiningOperationFour = "mining-operation-four",
  MiningMiningOperationFive = "mining-operation-five",
  MiningMiningOperationSix = "mining-operation-six",
  LegacyBusinessSector = "business-sector",
  LegacyBusinessVision = "business-vision",
  LegacyProductType = "product-type",
  LegacyAudienceLocation = "audience-location",
  LegacyAudienceAge = "audience-age",
  LegacyBrandLookAndFeel = "brand-look-and-feel",
  LegacyCommunityInspiration = "community-inspiration",
  LegacyAcquisitionBenefits = "acquisition-benefits",
  LegacyMemberBenefitsChurn = "member-benefits-churn",
  LegacyEmailTrigger = "email-trigger",
  LegacyCustomerServiceApproach = "customer-service-approach",
  LegacyLeadMagnet = "lead-magnet",
  LegacySearchStrategy = "search-strategy",
  LegacyCompetitorSearch = "competitor-search",
  LegacyOperationsFixedCosts = "operations-fixed-costs",
  LegacyOpsWorkflow1 = "ops-workflow1",
  LegacyOpsWorkflow2 = "ops-workflow2",
  LegacyOpsWorkflow3 = "ops-workflow3",
  LegacyCurrentSales = "current-sales",
  LegacyGrowthTurnover = "growth-turnover",
  LegacyStartupLocations = "startup-locations",
  LegacyStartupTamSamSom = "startup-tam-sam-som",
  LegacyStartupCasestudy = "startup-casestudy",
  LegacyStartupGrantAvailability = "startup-grant-availability",
  LegacyAboutPage = "about-page",
  LegacyBusinessEcosystem = "business-ecosystem",
  LegacyCompetitiveAnalysis = "competitive-analysis",
  LegacyCompetitiveKnown = "competitive-known",
  LegacyContentEditorial = "content-editorial",
  LegacyContentMerchandising = "content-merchandising",
  LegacyContentProduct = "content-product",
  LegacyContentRole = "content-role",
  LegacyEditorialCalendar = "editorial-calendar",
  LegacyEditorialMonth = "editorial-month",
  LegacyFaqPage = "faq-page",
  LegacyJobDescription = "job-description",
  LegacyLeadMagnetEmails = "lead-magnet-emails",
  LegacyMembershipBenefits = "membership-benefits",
  LegacyMembershipPrinciples = "membership-principles",
  LegacyMembershipRole = "membership-role",
  LegacyNewProduct = "new-product",
  LegacyNewProductName = "new-product-name",
  LegacyNewsletterApproach = "newsletter-approach",
  LegacyNoanAssessment = "noan-assessment",
  LegacyNoanGoals = "noan-goals",
  LegacyOnboardingApproach = "onboarding-approach",
  LegacyProductAssessment = "product-assessment",
  LegacyProductConcept = "product-concept",
  LegacySectorAnalysis = "sector-analysis",
  LegacyStaffBudget = "staff-budget",
  LegacyStaffingRecommendation = "staffing-recommendation",
  LegacyStartupPitchDeck = "startup-pitch-deck",
  LegacyUserResearch = "user-research",
  LegacyUserResearchFeedback = "user-research-feedback",
  LegacyWebsiteHomepage = "website-homepage",
  LegacyWebsiteNavigation = "website-navigation",
  LegacyWhitespace = "whitespace",
}

export const blockPathName = {
  [BlockPath.FoundationsCompanyName]: "Company Name",
  [BlockPath.FoundationsMonetizationModel]: "Monetization Model",
  [BlockPath.FoundationsOriginStory]: "Origin Story",
  [BlockPath.FoundationsExperienceWebsite]: "Website URL",
  [BlockPath.CustomerAudienceDescription]: "Audience Description",
  [BlockPath.CustomerAudienceInterests]: "Audience Interests",
  [BlockPath.CustomerIdealCustomer]: "Target Customer",
  [BlockPath.CustomerAudienceSegments]: "Audience Segmentation",
  [BlockPath.BrandBusinessImpact]: "Brand Purpose",
  [BlockPath.BrandMissionVision]: "Mission & Vision",
  [BlockPath.BrandBrandPositioning]: "Brand Positioning",
  [BlockPath.BrandBrandExperiencePrinciples]: "Brand Experience Principles",
  [BlockPath.BrandBrandIdentity]: "Brand Identity",
  [BlockPath.BrandValueProposition]: "Value Proposition",
  [BlockPath.BrandBrandTone]: "Brand Tone",
  [BlockPath.ProductProductList]: "Product List",
  [BlockPath.ProductProductFeatures]: "Key Product Feature Descriptions",
  [BlockPath.ProductProductFaq]: "Product FAQs",
  [BlockPath.ProductProductCaseStudies]: "Case Studies",
  [BlockPath.ProductProductDiscount]: "Product Discount Codes",
  [BlockPath.ProductProductStrategy]: "Product Strategy",
  [BlockPath.ProductProductRoadmap]: "Product Roadmap",
  [BlockPath.MembershipMembershipModel]: "Subscription Or Membership Model",
  [BlockPath.MembershipCommunityStrategy]: "Community Strategy",
  [BlockPath.MembershipMembershipStructure]: "Membership Structure",
  [BlockPath.MembershipMembershipApplicationCriteria]: "Membership Criteria",
  [BlockPath.MembershipMemberReferral]: "Member Referral",
  [BlockPath.ExperienceExperienceTechnologyPlatforms]: "Technology Platforms",
  [BlockPath.ExperienceUserOnboarding]: "User Onboarding",
  [BlockPath.ExperienceCustomerService]: "Customer Service",
  [BlockPath.ContentContentPositioning]: "Content Positioning",
  [BlockPath.ContentContentPrinciples]: "Content Principles",
  [BlockPath.ContentContentPillars]: "Content Pillars",
  [BlockPath.ContentSocialChannels]: "Social Channels",
  [BlockPath.ContentSocialStrategy]: "Social Strategy",
  [BlockPath.ContentContentInfluencer]: "Influencer Strategy",
  [BlockPath.ContentNewsletterFormat]: "Newsletter Format",
  [BlockPath.ContentContentOutboundEmailApproach]: "Outbound Email Approach",
  [BlockPath.ContentContentArticleFormat]: "Article Format",
  [BlockPath.ContentContentPressReleaseFormat]: "Press Release Format",
  [BlockPath.ContentContentCaseStudy]: "Case Study",
  [BlockPath.ContentContentQualityControl]: "Content Quality Control Checklist",
  [BlockPath.ContentContentGlossary]: "Content Glossary",
  [BlockPath.ContentContentComplianceRegulations]:
    "Content Compliance Regulations",
  [BlockPath.CommsAdvertisingNextQuarterGoals]: "Next Quarter Goals",
  [BlockPath.CommsMarketingGoal]: "Marketing Goal",
  [BlockPath.CommsUserPainpoints]: "Audience Pain Points",
  [BlockPath.CommsBarrierAssessment]: "Barrier Assessment",
  [BlockPath.CommsCommunicationGoals]: "Communication Goals",
  [BlockPath.CommsKeyMessages]: "Key Messages",
  [BlockPath.CommsSocialTactics]: "Social Tactics",
  [BlockPath.CommsBrandTaglines]: "Taglines",
  [BlockPath.CommsSocialCampaignChannel]: "Social Campaign Channel",
  [BlockPath.CommsSocialCampaignStrategy]: "Social Campaign Strategy",
  [BlockPath.CommsMarketingBudget]: "Marketing Budget",
  [BlockPath.CommsPaidAdvertising]: "Paid Advertising",
  [BlockPath.CommsGoogleAd]: "Google Ads",
  [BlockPath.OperationsBusinessStaffing]: "Staffing",
  [BlockPath.OperationsOperationsLeadershipBios]: "Leadership Bios",
  [BlockPath.OperationsContactDetails]: "Contact Details",
  [BlockPath.OperationsOperationsSocialHandles]: "Social Handles",
  [BlockPath.OperationsCookiePolicy]: "Cookie Policy",
  [BlockPath.OperationsPrivacyPolicy]: "Privacy Policy",
  [BlockPath.GrowthYearGoals]: "12-Month Goals",
  [BlockPath.GrowthGrowthMarketingObjectives]: "12 Month Marketing Objectives",
  [BlockPath.GrowthGrowthOkrs]: "Quarterly OKRs",
  [BlockPath.GrowthGrowthFiveYear]: "5 Year Plan",
  [BlockPath.GrowthQuarterlyPlanning]: "Quarterly Planning",
  [BlockPath.GrowthQuarterlyPromotion]: "Promotions",
  [BlockPath.GrowthGrowthGtmMetrics]: "GTM Metrics",
  [BlockPath.GrowthGrowthMetrics]: "Growth Metrics",
  [BlockPath.GrowthGrowthCampaignMetrics]: "Campaign Performance Metrics",
  [BlockPath.SalesSalesObjectivesMetrics]: "Sales Objectives & Success Metrics",
  [BlockPath.SalesSalesCustomerProfile]: "Ideal Customer Profile",
  [BlockPath.SalesSalesIcpTriggers]: "ICP Sales Triggers",
  [BlockPath.SalesSalesBuyerPersona]: "Buyer Personas",
  [BlockPath.SalesSalesBuyerSegments]: "Buyer Segments",
  [BlockPath.SalesSalesVertical]: "Target Vertical Use Cases",
  [BlockPath.SalesSalesPrinciples]: "Sales Principles",
  [BlockPath.SalesSalesProcess]: "Sales Process",
  [BlockPath.SalesOutboundEmailstrategy]: "Outbound Emails Sales Strategy",
  [BlockPath.SalesOutreachSalesstrategy]: "Outreach Sales Strategy",
  [BlockPath.SalesAffiliateSales]: "Affiliate Sales Strategy",
  [BlockPath.SalesSalesProposalFormat]: "Sales Proposal Format",
  [BlockPath.PartnershipsMembershipPartnerships]: "Partnership Strategy",
  [BlockPath.PartnershipsPartnershipsCurrent]: "Partners",
  [BlockPath.PartnershipsPartnershipsAffiliate]: "Affiliate Program",
  [BlockPath.PolicyPolicyAi]: "AI Policy",
  [BlockPath.PolicyPolicyPrivacy]: "Privacy Policy",
  [BlockPath.PolicyPolicyHr]: "HR Policy",
  [BlockPath.PolicyPolicyData]: "Data Policy",
  [BlockPath.PolicyPolicyBoardGovernance]: "Board Governance",
  [BlockPath.PolicyPolicyAdvocacy]: "Advocacy Policy",
  [BlockPath.PolicyPolicyBylawsGovernance]: "Bylaws and Governance",
  [BlockPath.PolicyPolicyAntiBriberyCorruption]:
    "Anti-Bribery and Corruption Policy",
  [BlockPath.PolicyPolicyCodeConduct]: "Code of Conduct",
  [BlockPath.PolicyPolicyHsecs]: "HSECS Policy",
  [BlockPath.PolicyPolicyItAcceptableUsePolicy]: "IT Acceptable Use Policy",
  [BlockPath.PolicyPolicyCrimePreventionPolicy]: "Crime Prevention Policy",
  [BlockPath.HrHrJobdescription]: "Job Description Format",
  [BlockPath.HrHrProcess]: "Hiring Process",
  [BlockPath.SustainabilitySustainabilityPolicy]: "Sustainability Policy",
  [BlockPath.SustainabilitySustainabilityGovernance]:
    "Sustainability Governance",
  [BlockPath.SustainabilitySustainabilityStrategicFrameworkNarrative]:
    "Strategic Framework Narrative",
  [BlockPath.SustainabilitySustainabilityStrategicFrameworkData]:
    "Strategic Framework Data",
  [BlockPath.SustainabilitySustainabilityEconomicContributionNarrative]:
    "Economic Contribution Narrative",
  [BlockPath.SustainabilitySustainabilityEconomicContributionData]:
    "Economic Contribution Data",
  [BlockPath.SustainabilitySustainabilityInnovationNarrative]:
    "Innovation Narrative",
  [BlockPath.SustainabilitySustainabilityInnovationData]: "Innovation Data",
  [BlockPath.SustainabilitySustainabilityGovernanceNarrative]:
    "Governance Narrative",
  [BlockPath.SustainabilitySustainabilityGovernanceData]: "Governance Data",
  [BlockPath.SustainabilitySustainabilityComplianceNarrative]:
    "Compliance Narrative",
  [BlockPath.SustainabilitySustainabilityComplianceData]: "Compliance Data",
  [BlockPath.SustainabilitySustainabilityHumanRightsNarrative]:
    "Human Rights Narrative",
  [BlockPath.SustainabilitySustainabilityHumanRightsData]: "Human Rights Data",
  [BlockPath.SustainabilitySustainabilityRiskManagementNarrative]:
    "Risk Management Narrative",
  [BlockPath.SustainabilitySustainabilityCyberSecurityNarrative]:
    "Cyber Security Narrative",
  [BlockPath.SustainabilitySustainabilityCyberSecurityData]:
    "Cyber Security Data",
  [BlockPath.SustainabilitySustainabilityPeopleSocietyNarrative]:
    "People & Society Narrative",
  [BlockPath.SustainabilitySustainabilityPeopleSocietyData]:
    "People & Society Data",
  [BlockPath.SustainabilitySustainabilityHealthSafetyNarrative]:
    "Health & Safety Narrative",
  [BlockPath.SustainabilitySustainabilityHealthSafetyData]:
    "Health & Safety Data",
  [BlockPath.SustainabilitySustainabilityWorkersNarrative]: "Workers Narrative",
  [BlockPath.SustainabilitySustainabilityWorkersData]: "Workers Data",
  [BlockPath.SustainabilitySustainabilityCommunitiesNarrative]:
    "Communities Narrative",
  [BlockPath.SustainabilitySustainabilityCommunitiesData]: "Communities Data",
  [BlockPath.SustainabilitySustainabilitySuppliersNarrative]:
    "Suppliers Narrative",
  [BlockPath.SustainabilitySustainabilitySuppliersData]: "Suppliers Data",
  [BlockPath.SustainabilitySustainabilityEnvironmentNarrative]:
    "Environment Narrative",
  [BlockPath.SustainabilitySustainabilityEnvironmentData]: "Environment Data",
  [BlockPath.SustainabilitySustainabilityEnvironmentalManagementNarrative]:
    "Environmental Management Narrative",
  [BlockPath.SustainabilitySustainabilityEnvironmentalManagementData]:
    "Environmental Management Data",
  [BlockPath.SustainabilitySustainabilityClimateChangeNarrative]:
    "Climate Change & Decarbonization Narrative",
  [BlockPath.SustainabilitySustainabilityClimateChangeData]:
    "Climate Change & Decarbonization Data",
  [BlockPath.SustainabilitySustainabilityEnergyManagementNarrative]:
    "Energy Management Narrative",
  [BlockPath.SustainabilitySustainabilityEnergyManagementData]:
    "Energy Management Data",
  [BlockPath.SustainabilitySustainabilityWaterStewardshipNarrative]:
    "Water Stewardship Narrative",
  [BlockPath.SustainabilitySustainabilityWaterStewardshipData]:
    "Water Stewardship Data",
  [BlockPath.SustainabilitySustainabilityCircularEconomyNarrative]:
    "Circular Economy Narrative",
  [BlockPath.SustainabilitySustainabilityCircularEconomyData]:
    "Circular Economy Data",
  [BlockPath.SustainabilitySustainabilityTailingsNarrative]:
    "Tailings Narrative",
  [BlockPath.SustainabilitySustainabilityTailingsData]: "Tailings Data",
  [BlockPath.SustainabilitySustainabilityBiodiversityNarrative]:
    "Biodiversity Protection Narrative",
  [BlockPath.SustainabilitySustainabilityBiodiversityData]:
    "Biodiversity Protection Data",
  [BlockPath.SustainabilitySustainabilityStakeholderEngagementNarrative]:
    "Stakeholder Engagement Narrative",
  [BlockPath.SustainabilitySustainabilityStakeholderEngagementData]:
    "Stakeholder Engagement Data",
  [BlockPath.SponsorshipsSponsorshipTypes]: "Sponsorship Types",
  [BlockPath.SponsorshipsSponsorshipsPackages]: "Sponsorship Packages",
  [BlockPath.SponsorshipsSponsorshipCurrent]: "Current Sponsors",
  [BlockPath.SponsorshipsSponsorshipCriteria]: "Sponsorship Criteria",
  [BlockPath.PodcastPodcastConceptPositioning]: "Podcast Concept & Positioning",
  [BlockPath.PodcastPodcastGoalsKpis]: "Podcast Goals & KPIs",
  [BlockPath.PodcastPodcastAudiencePersona]: "Audience Persona",
  [BlockPath.PodcastPodcastEpisodePlanningStrategy]: "Podcast Episode Plan",
  [BlockPath.PodcastPodcastGuestDescription]: "Target Guest Description",
  [BlockPath.PodcastPodcastDistributionChannels]: "Distribution Channels",
  [BlockPath.PodcastPodcastBrandingGuidelines]:
    "Branding & Creative Guidelines",
  [BlockPath.PodcastPodcastMonetizationSponsorship]:
    "Monetization & Sponsorship",
  [BlockPath.GrantsGrantsMakerProfile]: "Grantmaker Financial Profile",
  [BlockPath.GrantsGrantsImpactPortfolio]:
    "Impact-Investing Profile & Portfolio",
  [BlockPath.GrantsGrantsPrograms]: "Grantmaking Programs and Initiatives",
  [BlockPath.GrantsGrantsApplicationProcess]:
    "Grantmaking Policy and Application Process",
  [BlockPath.GrantsGrantsTypeSize]: "Grant types and size",
  [BlockPath.GrantsGrantsEligibility]: "Grantee Types Eligibility",
  [BlockPath.GrantsGrantsGrantees]: "Non-profit Grantees",
  [BlockPath.GrantsGrantsLiveProposals]: "Live Calls for Proposals",
  [BlockPath.EventsEventsFacilities]: "Facilities",
  [BlockPath.EventsEventsPackages]: "Packages",
  [BlockPath.EventsEventSponsorshipsPackages]: "Sponsorship Packages",
  [BlockPath.EventsEventsFood]: "Food",
  [BlockPath.EventsEventsDrinks]: "Drinks",
  [BlockPath.EventsEventsTravel]: "Travel",
  [BlockPath.EventsEventsOperations]: "Operational Details",
  [BlockPath.DesignerDesignerEthos]: "Design Ethos",
  [BlockPath.DesignerDesignerCapabilities]: "Design Capabilities",
  [BlockPath.DesignerDesignerProcess]: "Design Process",
  [BlockPath.DesignerDesignerProposal]: "Proposal Structure",
  [BlockPath.EducationEducationType]: "Education Type",
  [BlockPath.EducationEducationStudentLevel]: "Student Level",
  [BlockPath.EducationEducationClasses]: "Classes",
  [BlockPath.EducationEducationFunding]: "Funding Type",
  [BlockPath.EducationEducationFees]: "Tuition Fees",
  [BlockPath.EducationEducationFacilities]: "Facilities",
  [BlockPath.EducationEducationAlumni]: "Alumni Testinomials",
  [BlockPath.EducationEducationExtracurricular]: "Extracurricular Activities",
  [BlockPath.StartupStartupProblem]: "What Problem Do You Solve?",
  [BlockPath.StartupStartupCompanyLocation]: "Company Structure",
  [BlockPath.StartupStartupFundraisingStatus]: "Fundraising Status",
  [BlockPath.StartupStartupInvestorProfile]: "Investor target profile",
  [BlockPath.StartupStartupElevatorPitch]: "Elevator Pitch",
  [BlockPath.StartupStartupInvestorUpdate]: "Investor Update Template",
  [BlockPath.PublisherMediaPublisherMediaCitywire]: "Citywire",
  [BlockPath.PublisherMediaPublisherMediaFuture]: "Future",
  [BlockPath.PublisherMediaPublisherMediaIncisive]: "Incisive",
  [BlockPath.PublisherMediaPublisherMediaTrustnet]: "Trustnet",
  [BlockPath.PublisherMediaPublisherMediaFtadviser]: "FT Adviser",
  [BlockPath.PublisherMediaPublisherMediaFinancialTimes]: "Financial Times",
  [BlockPath.PublisherMediaPublisherMediaTelegraph]: "Telegraph",
  [BlockPath.PublisherMediaPublisherMediaTheTimes]: "The Times",
  [BlockPath.PublisherMediaPublisherMediaSpectator]: "Spectator",
  [BlockPath.PublisherMediaPublisherMediaNewStatesman]: "News Statesman",
  [BlockPath.PublisherMediaPublisherMediaGuardian]: "Guardian",
  [BlockPath.PublisherMediaPublisherMediaObserver]: "Observer",
  [BlockPath.PublisherMediaPublisherMediaEconomist]: "Economist",
  [BlockPath.PublisherMediaPublisherMediaPerspectivePublishing]:
    "Perspective Publishing",
  [BlockPath.PublisherMediaPublisherMediaWealthWise]: "Wealth Wise",
  [BlockPath.PublisherMediaPublisherMediaFundsEurope]: "Funds Europe",
  [BlockPath.PublisherMediaPublisherMediaAssetTv]: "Asset TV",
  [BlockPath.PublisherMediaPublisherMediaIfaMagazine]: "IFA Magazine",
  [BlockPath.PublisherMediaPublisherMediaPortfolioAdviser]: "Portfolio Adviser",
  [BlockPath.PublisherMediaPublisherMediaMobkoi]: "Mobkoi",
  [BlockPath.PublisherMediaPublisherMediaSmartology]: "Smartology",
  [BlockPath.PublisherMediaPublisherMediaDianomi]: "Dianomi",
  [BlockPath.PublisherMediaPublisherMediaMorningstar]: "Morningstar",
  [BlockPath.PublisherMediaPublisherMediaTeads]: "Teads",
  [BlockPath.PublisherMediaPublisherMediaSkyAdsmart]: "Sky Adsmart",
  [BlockPath.PublisherMediaPublisherMediaRadioWorks]: "Radio Works",
  [BlockPath.PublisherMediaPublisherMediaQubeOoh]: "Qube - OOH",
  [BlockPath.FarmFarmType]: "Farm Type",
  [BlockPath.FarmFarmSize]: "Farm Size & Field Number",
  [BlockPath.FarmFarmEnvironmentalprograms]: "Environmental Programs",
  [BlockPath.FarmCropTypes]: "Crop Types",
  [BlockPath.FarmLivestockTypes]: "Livestock Types",
  [BlockPath.FarmFarmProduce]: "Produce",
  [BlockPath.FarmFarmEquipment]: "Farm Equipment",
  [BlockPath.FarmFarmCultivation]: "Cultivation Techniques",
  [BlockPath.FarmFarmProcesses]: "Specialist Processes",
  [BlockPath.FarmFarmFieldKnowledge]: "Field Knowledge",
  [BlockPath.EcommEcommShipping]: "Shipping Location",
  [BlockPath.EcommEcommReturnDetails]: "Return Details",
  [BlockPath.EcommEcommReturns]: "Returns Policy",
  [BlockPath.EfuelsEfuelsFacilitiesOne]: "eFuels Facilities One",
  [BlockPath.EfuelsEfuelsFacilitiesTwo]: "eFuels Facilities Two",
  [BlockPath.EfuelsEfuelsFacilitiesThree]: "eFuels Facilities Three",
  [BlockPath.EfuelsEfuelsFacilitiesFour]: "eFuels Facilities Four",
  [BlockPath.EfuelsEfuelsFacilitiesFive]: "eFuels Facilities Five",
  [BlockPath.EfuelsEfuelsFacilitiesSix]: "eFuels Facilities Six",
  [BlockPath.EfuelsEfuelsFacilitiesSeven]: "eFuels Facilities Seven",
  [BlockPath.EfuelsEfuelsFacilitiesEight]: "eFuels Facilities Eight",
  [BlockPath.EfuelsEfuelsFacilitiesNine]: "eFuels Facilities Nine",
  [BlockPath.EfuelsEfuelsFacilitiesTen]: "eFuels Facilities Ten",
  [BlockPath.EfuelsEfuelsGlobalGoals]: "2025 Global Goals",
  [BlockPath.EfuelsEfuelsDirectAirCapture]: "Direct Air Capture (DAC)",
  [BlockPath.EfuelsEfuelsModularisation]: "Modularisation",
  [BlockPath.EfuelsEfuelsAdvocacy]: "Efuels Advocacy",
  [BlockPath.EfuelsEfuelsInternationalPolicy]: "Efuels International Policy",
  [BlockPath.TravelTravelLocations]: "Locations",
  [BlockPath.TravelTravelAvailability]: "Availability",
  [BlockPath.TravelTravelLocationtimes]: "Location Open Times",
  [BlockPath.TravelTravelReseller]: "3rd Party Reseller Strategy",
  [BlockPath.ConsultingConsultingSpeciality]: "Expertise Speciality Areas",
  [BlockPath.ConsultingDiscoveryApproach]: "Discovery Approach",
  [BlockPath.ConsultingConsultingProcess]: "Consulting Process",
  [BlockPath.ConsultingConsultingProposal]: "Proposal Structure",
  [BlockPath.ConsultingConsultingHourlyRate]: "Staffing Hourly Rate",
  [BlockPath.ConsultingConsultingInterviewGuide]: "Interview Guide",
  [BlockPath.ConsultingConsultingKickoffAgenda]: "Kick Off Meeting Agenda",
  [BlockPath.ConsultingConsultingWeeklyMeetingAgenda]:
    "Weekly Project Meeting Agenda",
  [BlockPath.ConsultingConsultingProjectFeedbackAgenda]:
    "Project Feedback Meeting Agenda",
  [BlockPath.ConsultingConsultingProjectStatus]: "Project Status Update",
  [BlockPath.ArchitectArchitectureType]: "Building Types",
  [BlockPath.ArchitectArchitectureConstruction]: "Construction Approach",
  [BlockPath.ArchitectArchitectureServices]: "Services",
  [BlockPath.ArchitectArchitectureWork]: "Past Work",
  [BlockPath.WineWineGrapes]: "Grape Varietals",
  [BlockPath.WineWinePhilosophy]: "Winemaking Philosophy",
  [BlockPath.WineWineVineyard]: "Vineyard Details",
  [BlockPath.WineWineTerroir]: "Terroir",
  [BlockPath.WineWineTour]: "Wine Tours",
  [BlockPath.WineRedWineList]: "Red Wine List",
  [BlockPath.WineWhiteWineList]: "White Wine List",
  [BlockPath.WineMiscWineList]: "Misc Wine List",
  [BlockPath.BeverageBeveragesTypes]: "Beverage Types",
  [BlockPath.BeverageBeverageVarieties]: "Ingredients",
  [BlockPath.BeverageBeverageProduction]: "Production Processes",
  [BlockPath.BeverageBeverageTasting]: "Tasting Notes",
  [BlockPath.BeverageBeveragePremises]: "Premises Details",
  [BlockPath.BeverageBeverageDistribution]: "Distribution Approach",
  [BlockPath.AccommodationAccommodationType]: "Accommodation Type",
  [BlockPath.AccommodationAccommodationLocations]: "Accommodation Locations",
  [BlockPath.AccommodationAccommodationDescription]:
    "Accommodation Description",
  [BlockPath.AccommodationAccommodationPackages]: "Accommodation Packages",
  [BlockPath.AccommodationAccommodationRules]: "Accommodation Rules",
  [BlockPath.AccommodationAccommodationContact]: "Contact Details",
  [BlockPath.SelfStorageStorageType]: "Storage type",
  [BlockPath.SelfStorageStorageArea]: "Area Size",
  [BlockPath.SelfStorageStorageRules]: "Storage Rules",
  [BlockPath.SelfStorageStorageRent]: "Storage Rent",
  [BlockPath.SelfStorageStorageSecurity]: "Storage Security",
  [BlockPath.SelfStorageStorageContact]: "Contact Details",
  [BlockPath.RestaurantRestaurantType]: "Restaurant type",
  [BlockPath.RestaurantRestaurantMenu]: "Menu",
  [BlockPath.RestaurantRestaurantSignatureDish]: "Signature dishes",
  [BlockPath.RestaurantRestaurantPriorityDish]: "Priority menu items",
  [BlockPath.RestaurantRestaurantCrossSell]: "Cross-selling strategy",
  [BlockPath.RestaurantRestaurantMenuPackaging]: "Menu Packaging",
  [BlockPath.RealEstateRealEstateType]: "Building Type",
  [BlockPath.RealEstateRealEstateLocations]: "Building Locations",
  [BlockPath.RealEstateRealEstateComplaint]: "Complaints Process",
  [BlockPath.DentistDentistTypes]: "Dentistry Types",
  [BlockPath.DentistDentistTeam]: "Team Qualifications",
  [BlockPath.DoctorDoctorField]: "Medical Field",
  [BlockPath.DoctorDoctorTeam]: "Team",
  [BlockPath.DoctorDoctorQualifications]: "Qualifications",
  [BlockPath.DoctorDoctorInsurance]: "Insurance",
  [BlockPath.CharityNonprofitName]: "Nonprofit Name",
  [BlockPath.CharityNonprofitType]: "Nonprofit type",
  [BlockPath.CharityNonprofitLocations]: "Your locations",
  [BlockPath.CharityNonprofitFramework]: "Non-Profit Ethical Framework",
  [BlockPath.CharityNonprofitImpactModel]: "Impact Change Model",
  [BlockPath.CharityNonprofitBeneficiary]: "Beneficiary type",
  [BlockPath.CharityNonprofitBeneficiaryGroups]:
    "Beneficiary Population Groups",
  [BlockPath.CharityNonprofitMissionObjectives]: "Mission Objectives",
  [BlockPath.CharityNonprofitImpactPrograms]: "Impact Programs and Initiatives",
  [BlockPath.CharityNonprofitMetrics]: "Impact Assessment & Metrics",
  [BlockPath.CharityNonprofitGovernance]: "Board Governance Structure",
  [BlockPath.CharityNonprofitPartnerships]: "Collaborative Partnerships",
  [BlockPath.CharityNonprofitFundMix]: "Current funding mix",
  [BlockPath.CharityNonprofitGrants]: "Grant Availability",
  [BlockPath.CharityNonprofitDonorTypes]: "Donor types",
  [BlockPath.CharityNonprofitTactics]: "Fundraising Tactics",
  [BlockPath.AgencyAgencyType]: "Agency Type",
  [BlockPath.AgencyAgencyCapabilities]: "Agency Capabilities",
  [BlockPath.AgencyAgencyProcess]: "Agency Process",
  [BlockPath.AgencyAgencySpeciality]: "Speciality Process",
  [BlockPath.AgencyAgencyCasestudies]: "Agency Case Studies",
  [BlockPath.AgencyAgencyAwards]: "Agency Recognition",
  [BlockPath.AgencyAgencySow]: "Example SOW",
  [BlockPath.AgencyAgencyRates]: "Remuneration Approach",
  [BlockPath.AgencyAgencyTestimonials]: "Client Testimonials",
  [BlockPath.AgencyAgencyLeads]: "Target Clients",
  [BlockPath.ConstructionConstructionTypes]: "Construction Types",
  [BlockPath.ConstructionConstructionTeam]: "Construction Team",
  [BlockPath.ConstructionConstructionOverhead]: "Fixed Overhead Costs",
  [BlockPath.ConstructionConstructionOverheadVariable]:
    "Variable Overhead Costs",
  [BlockPath.ConstructionConstructionBilling]: "Hourly Billing",
  [BlockPath.FundFundName]: "Fund Name",
  [BlockPath.FundFundSize]: "Fund Size",
  [BlockPath.FundFundThesis]: "Investment Thesis",
  [BlockPath.FundFundStage]: "Investment stage",
  [BlockPath.FundFundDate]: "Fund Launch Date",
  [BlockPath.FundCheckSize]: "Check Size",
  [BlockPath.FundFundProcess]: "Process",
  [BlockPath.FundFundPortfolio]: "Portfolio",
  [BlockPath.ManufacturingManufacturingIndustries]: "Industries",
  [BlockPath.ManufacturingManufacturingSubsidiary]: "Subsidiary Brands",
  [BlockPath.ManufacturingManufacturingProcess]: "Manufacturing Process",
  [BlockPath.ManufacturingManufacturingMaterials]: "Material Types",
  [BlockPath.ManufacturingManufacturingSolutions]: "Solutions",
  [BlockPath.CoachCoachType]: "Coaching Type",
  [BlockPath.CoachCoachQualifications]: "Coaching Qualifications",
  [BlockPath.CoachCoachPhilosophy]: "Coaching Philosophy",
  [BlockPath.CoachCoachCourse]: "Course Structure",
  [BlockPath.CoachCoachMethod]: "Coaching Methods",
  [BlockPath.CoachCoachTechniques]: "Specific Techniques",
  [BlockPath.CoachCoachCaseStudies]: "Case Studies",
  [BlockPath.SportsTeamSportsTeamGround]: "Ground Details",
  [BlockPath.SportsTeamSportsTeamCoaching]: "Coaching Staff",
  [BlockPath.SportsTeamSportsTeamPlayers]: "Players",
  [BlockPath.SportsTeamSportsTeamFeatures]: "Fixtures",
  [BlockPath.SportsTeamSportsTeamSponsors]: "Sponsors",
  [BlockPath.PersonalTrainerExerciseTypes]: "Training Type",
  [BlockPath.PersonalTrainerExerciseEquipment]: "Training Equipment",
  [BlockPath.PersonalTrainerTrainingPhilosophy]: "Training Philosophy",
  [BlockPath.PersonalTrainerDietPhilosophy]: "Diet-Philosophy",
  [BlockPath.PersonalTrainerProgramDesign]: "Program Design",
  [BlockPath.PersonalTrainerSuccessStories]: "Success Stories",
  [BlockPath.GymGymOpeningTimes]: "Opening Times",
  [BlockPath.GymGymEquipment]: "Equipment",
  [BlockPath.GymGymClasses]: "Classes",
  [BlockPath.AthleteAthleteSport]: "Sport",
  [BlockPath.AthleteAthleteSponsors]: "Sponsors",
  [BlockPath.AthleteAthleteAchievements]: "Achievements",
  [BlockPath.ClimbingGymClimbingLocations]: "Locations & Opening Times",
  [BlockPath.ClimbingGymClimbingTypes]: "Climbing Type",
  [BlockPath.ClimbingGymClimbingEthos]: "Climbing Gym Ethos",
  [BlockPath.ClimbingGymClimbingPasses]: "Passes",
  [BlockPath.ClimbingGymClimbingTraining]: "Training facilities",
  [BlockPath.ClimbingGymClimbingClasses]: "Classes",
  [BlockPath.ClimbingGymClimbingSafety]: "Safety Requirements",
  [BlockPath.GolfClubGolfCourse]: "Course Type",
  [BlockPath.GolfClubGolfEthos]: "Club Ethos",
  [BlockPath.GolfClubGolfFacilities]: "Facilities",
  [BlockPath.GolfClubGolfCourseGuide]: "Course Guide",
  [BlockPath.GolfClubGolfCompetitions]: "Competitions",
  [BlockPath.GolfClubGolfTeams]: "Teams",
  [BlockPath.LandManagementLandSize]: "Land Size",
  [BlockPath.LandManagementLandType]: "Land Type",
  [BlockPath.LandManagementLandPurpose]: "Strategic Purpose",
  [BlockPath.LandManagementLandGoals]: "Strategic Goals",
  [BlockPath.LandManagementLandPolicies]: "Land Policies",
  [BlockPath.LandManagementLandRental]: "Rental Strategy",
  [BlockPath.LandManagementLandCapital]: "Capital Strategy",
  [BlockPath.LandManagementLandEnvironmentalStrategy]: "Environmental Strategy",
  [BlockPath.LandManagementLandSocial]: "Social Strategy",
  [BlockPath.LandManagementLandWildlife]: "Wildlife Management",
  [BlockPath.LandManagementLandTeam]: "Team",
  [BlockPath.RetailRetailPrinciples]: "Store Design Principles",
  [BlockPath.RetailRetailCustomerService]: "Customer Service Principles",
  [BlockPath.RetailRetailSeasonalCampaignBrief]:
    "Seasonal Campaign Brief Template",
  [BlockPath.RetailRetailCampaignSignOff]: "Seasonal Campaign Sign Off Process",
  [BlockPath.RetailRetailOpeningPlan]: "Store Opening Plan",
  [BlockPath.RetailRetailWholesale]: "Wholesale Model",
  [BlockPath.RetailRetailConcessions]: "Concession Partners",
  [BlockPath.ResearchResearchMarket]: "Market Insights",
  [BlockPath.ResearchResearchConsumer]: "Consumer Insights",
  [BlockPath.ResearchResearchCompetitor]: "Competitor Insights",
  [BlockPath.ResearchResearchAudienceInsights]: "Audience Insights",
  [BlockPath.BuildingManagementBuildingAlterationPolicy]: "Alteration Policy",
  [BlockPath.BuildingManagementBuildingAlterationApplication]:
    "Alteration Application",
  [BlockPath.BuildingManagementBuildingSubletGuide]:
    "Subleasing you apartment guide",
  [BlockPath.BuildingManagementBuildingSubletRider]: "Sublet Lease Rider",
  [BlockPath.BuildingManagementBuildingSubletApplication]: "Sublet Application",
  [BlockPath.BuildingManagementBuildingDecorationApplication]:
    "Decoration Application",
  [BlockPath.BuildingManagementBuildingSalesPolicy]: "Sales Policy",
  [BlockPath.BuildingManagementBuildingSalesApplication]: "Sales Application",
  [BlockPath.BuildingManagementBuildingClosingInstructions]:
    "Closing Instructions Documents",
  [BlockPath.BuildingManagementBuildingHowGuide]: "How to live in the building",
  [BlockPath.BuildingManagementBuildingDuesPayments]: "Dues Payments",
  [BlockPath.BuildingManagementBuildingMaintenance]: "Maintenance Requests",
  [BlockPath.BuildingManagementTrashManagement]: "Trash Management",
  [BlockPath.BuildingManagementStorageWaivers]: "Storage & Bike Waivers",
  [BlockPath.BuildingManagementBuildingMovingPolicy]: "Move In & Out Policy",
  [BlockPath.BuildingManagementBuildingHomeowners]: "Homeowners Insurance",
  [BlockPath.BuildingManagementBuildingRefiProcess]: "Refi Process Doc",
  [BlockPath.BuildingManagementBuildingRefiPolicy]: "Refi Policy",
  [BlockPath.BuildingManagementBuildingRefiApplication]: "Refi Application",
  [BlockPath.BuildingManagementBuildingTrustEstate]: "Trust & Estates",
  [BlockPath.BuildingManagementBuildingCertificateIncorporation]:
    "Certificate of Incorporation",
  [BlockPath.BuildingManagementBuildingDeclarationCondominium]:
    "Declaration of Condominium",
  [BlockPath.BuildingManagementBuildingOfferingPlan]: "Offering Plan",
  [BlockPath.BuildingManagementBuildingSubscriptionAgreement]:
    "Subscription Agreement",
  [BlockPath.BuildingManagementBuildingBylaws]: "Bylaws",
  [BlockPath.BuildingManagementBuildingProprietaryLease]: "Proprietary Lease",
  [BlockPath.BuildingManagementBuildingPlans]: "Condominium Map/Floor Plans",
  [BlockPath.BuildingManagementBuildingHouseRules]: "House Rules",
  [BlockPath.LawyerLawyerServices]: "Services",
  [BlockPath.LawyerLawyerClients]: "Representative Clients",
  [BlockPath.MiningMiningOperationOne]: "Mining Operation One",
  [BlockPath.MiningMiningOperationTwo]: "Mining Operation Two",
  [BlockPath.MiningMiningOperationThree]: "Mining Operation Three",
  [BlockPath.MiningMiningOperationFour]: "Mining Operation Four",
  [BlockPath.MiningMiningOperationFive]: "Mining Operation Five",
  [BlockPath.MiningMiningOperationSix]: "Mining Operation Six",
  [BlockPath.LegacyBusinessSector]: "Business Sector",
  [BlockPath.LegacyBusinessVision]: "Business Vision",
  [BlockPath.LegacyProductType]: "Product Type",
  [BlockPath.LegacyAudienceLocation]: "Audience Location",
  [BlockPath.LegacyAudienceAge]: "Audience Age",
  [BlockPath.LegacyBrandLookAndFeel]: "Look & Feel",
  [BlockPath.LegacyCommunityInspiration]: "Community Inspiration",
  [BlockPath.LegacyAcquisitionBenefits]: "Acquisition Benefits",
  [BlockPath.LegacyMemberBenefitsChurn]: "Churn Benefits",
  [BlockPath.LegacyEmailTrigger]: "Trigger Email",
  [BlockPath.LegacyCustomerServiceApproach]: "Customer Service Approach",
  [BlockPath.LegacyLeadMagnet]: "Lead Magnet",
  [BlockPath.LegacySearchStrategy]: "Search Strategy",
  [BlockPath.LegacyCompetitorSearch]: "Competitor Search Strategy",
  [BlockPath.LegacyOperationsFixedCosts]: "Monthly Fixed Costs",
  [BlockPath.LegacyOpsWorkflow1]: "Company Workflow A",
  [BlockPath.LegacyOpsWorkflow2]: "Company Workflow B",
  [BlockPath.LegacyOpsWorkflow3]: "Company Workflow C",
  [BlockPath.LegacyCurrentSales]: "Monthly Sales",
  [BlockPath.LegacyGrowthTurnover]: "Annual Turnover",
  [BlockPath.LegacyStartupLocations]: "Locations",
  [BlockPath.LegacyStartupTamSamSom]: "TAM/SAM/SOM",
  [BlockPath.LegacyStartupCasestudy]: "Case Studies",
  [BlockPath.LegacyStartupGrantAvailability]: "Grant Availability",
  [BlockPath.LegacyAboutPage]: "About Page",
  [BlockPath.LegacyBusinessEcosystem]: "Ecosystem Assessment",
  [BlockPath.LegacyCompetitiveAnalysis]: "Competitive Analysis",
  [BlockPath.LegacyCompetitiveKnown]: "Known Competitors",
  [BlockPath.LegacyContentEditorial]: "Editorial Content",
  [BlockPath.LegacyContentMerchandising]: "Merchandising Content",
  [BlockPath.LegacyContentProduct]: "Product Content",
  [BlockPath.LegacyContentRole]: "Content Assessment",
  [BlockPath.LegacyEditorialCalendar]: "Content Calendar",
  [BlockPath.LegacyEditorialMonth]: "Content Calendar Selection",
  [BlockPath.LegacyFaqPage]: "FAQ Page",
  [BlockPath.LegacyJobDescription]: "Job Description",
  [BlockPath.LegacyLeadMagnetEmails]: "Lead Magnet Email Series",
  [BlockPath.LegacyMembershipBenefits]: "Membership Benefits",
  [BlockPath.LegacyMembershipPrinciples]: "Membership Principles",
  [BlockPath.LegacyMembershipRole]: "Membership Model Assessment",
  [BlockPath.LegacyNewProduct]: "New Product Description",
  [BlockPath.LegacyNewProductName]: "Product Name",
  [BlockPath.LegacyNewsletterApproach]: "Newsletter Approach",
  [BlockPath.LegacyNoanAssessment]: "NOAN Assessment",
  [BlockPath.LegacyNoanGoals]: "NOAN Goals",
  [BlockPath.LegacyOnboardingApproach]: "Onboarding Approach",
  [BlockPath.LegacyProductAssessment]: "Product Assessment",
  [BlockPath.LegacyProductConcept]: "Product Concept",
  [BlockPath.LegacySectorAnalysis]: "Sector Analysis",
  [BlockPath.LegacyStaffBudget]: "Staffing Budget",
  [BlockPath.LegacyStaffingRecommendation]: "Staffing Reccomendation",
  [BlockPath.LegacyStartupPitchDeck]: "Pitch Deck Structure",
  [BlockPath.LegacyUserResearch]: "Synthetic User Research",
  [BlockPath.LegacyUserResearchFeedback]: "User Research Feedback",
  [BlockPath.LegacyWebsiteHomepage]: "Homepage",
  [BlockPath.LegacyWebsiteNavigation]: "Navigation",
  [BlockPath.LegacyWhitespace]: "Whitespace",
} as const;
export const blockPathDescriptions = {
  [BlockPath.FoundationsCompanyName]:
    "The official registered name of the business entity",
  [BlockPath.FoundationsMonetizationModel]:
    "How the business generates (or plans to generate) revenue",
  [BlockPath.FoundationsOriginStory]:
    "The background narrative detailing the origins and establishment of the company",
  [BlockPath.FoundationsExperienceWebsite]: "The business website url",
  [BlockPath.CustomerAudienceDescription]:
    'The demographic and psychographic profile of the audience — age, location, lifestyle, attitudes, behaviours; the descriptive "what they\'re like", not a named persona or a sales-qualification profile',
  [BlockPath.CustomerAudienceInterests]:
    "The common hobbies, preferences, and activities that engage the target audience",
  [BlockPath.CustomerIdealCustomer]:
    "The single highest-level definition of who the business serves — the core customer type or firmographic group, stated briefly; not a detailed persona or demographic profile",
  [BlockPath.CustomerAudienceSegments]:
    "The distinct groups within the overall audience differentiated by specific characteristics",
  [BlockPath.BrandBusinessImpact]:
    "Why you exist beyond making money, the impact the business has on users' lives, or the planet at large.",
  [BlockPath.BrandMissionVision]:
    "The concise statements outlining the company’s purpose and future aspirations",
  [BlockPath.BrandBrandPositioning]:
    "The strategic description of how the brand is perceived relative to competitors in the market",
  [BlockPath.BrandBrandExperiencePrinciples]:
    "The core guidelines that shape customer interactions and perceptions of the brand",
  [BlockPath.BrandBrandIdentity]:
    "The collection of visual, verbal, and experiential elements that represent the brand",
  [BlockPath.BrandValueProposition]:
    "The clear statement of benefits and unique value offered to customers by the brand or product",
  [BlockPath.BrandBrandTone]:
    "The characteristic style and manner of communication used by the brand",
  [BlockPath.ProductProductList]:
    "The products and services the company currently offers",
  [BlockPath.ProductProductFeatures]:
    "The specific attributes, functionalities, and qualities of each product",
  [BlockPath.ProductProductFaq]:
    "The common questions and corresponding answers related to the products",
  [BlockPath.ProductProductCaseStudies]:
    "The documented examples demonstrating product use and effectiveness in real scenarios",
  [BlockPath.ProductProductDiscount]:
    "The details of pricing reductions, promotions, and special offers available for products",
  [BlockPath.ProductProductStrategy]:
    "The planned approach for product development and lifecycle management",
  [BlockPath.ProductProductRoadmap]:
    "The timeline and planned milestones for future product releases and enhancements",
  [BlockPath.MembershipMembershipModel]:
    "The structure and rules governing membership types, access, and benefits",
  [BlockPath.MembershipCommunityStrategy]:
    "The planned methods and activities to build, grow, and sustain the community",
  [BlockPath.MembershipMembershipStructure]:
    "The organization and hierarchy of membership levels and associated privileges",
  [BlockPath.MembershipMembershipApplicationCriteria]:
    "The application criteria you used to judge whether users can join a membership",
  [BlockPath.MembershipMemberReferral]:
    "The programs and incentives designed to encourage existing members to recruit others",
  [BlockPath.ExperienceExperienceTechnologyPlatforms]:
    "The technology platforms currently used to deliver products or services",
  [BlockPath.ExperienceUserOnboarding]:
    "The process and materials used to introduce and acclimate new users or customers",
  [BlockPath.ExperienceCustomerService]:
    "The operational approach dedicated to assisting customers",
  [BlockPath.ContentContentPositioning]:
    "The strategic framing and messaging of content to align with brand goals and audience needs",
  [BlockPath.ContentContentPrinciples]:
    "Fundamental guidelines defining the approach and standards for creating and managing content",
  [BlockPath.ContentContentPillars]:
    "Core themes or topics that structure and support the overall content strategy",
  [BlockPath.ContentSocialChannels]:
    "List and characteristics of social media platforms used for content distribution and audience engagement",
  [BlockPath.ContentSocialStrategy]:
    "Planned approach for leveraging social media platforms to achieve marketing and communication objectives",
  [BlockPath.ContentContentInfluencer]:
    "The approach to working with influential people to engage an audience",
  [BlockPath.ContentNewsletterFormat]:
    "Structure and design elements defining the layout and presentation of email newsletters",
  [BlockPath.ContentContentOutboundEmailApproach]:
    "Tactics and messaging frameworks used for proactive email communication to target audiences",
  [BlockPath.ContentContentArticleFormat]:
    "Standardized layout and structural elements defining the presentation of written articles",
  [BlockPath.ContentContentPressReleaseFormat]:
    "Template and structural guidelines for composing official announcements intended for media distribution",
  [BlockPath.ContentContentCaseStudy]:
    "Detailed accounts showcasing real-world examples of product or service applications and outcomes",
  [BlockPath.ContentContentQualityControl]:
    "Procedures and criteria for reviewing and ensuring the accuracy, relevance, and consistency of content",
  [BlockPath.ContentContentGlossary]:
    "Alphabetical list of key terms and definitions relevant to the business and its content",
  [BlockPath.ContentContentComplianceRegulations]:
    "Rules and standards governing content to ensure legal and ethical adherence",
  [BlockPath.CommsAdvertisingNextQuarterGoals]:
    "Specific objectives the business aims to achieve within the defined timeframe",
  [BlockPath.CommsMarketingGoal]:
    "Targeted outcomes intended to be accomplished through marketing efforts",
  [BlockPath.CommsUserPainpoints]:
    "Identified challenges and problems experienced by the target audience",
  [BlockPath.CommsBarrierAssessment]:
    "Evaluation of obstacles that hinder customer engagement or business success",
  [BlockPath.CommsCommunicationGoals]:
    "Desired effects and outcomes from internal and external messaging activities",
  [BlockPath.CommsKeyMessages]:
    "Core points and themes to be consistently conveyed across communications",
  [BlockPath.CommsSocialTactics]:
    "Specific actions and initiatives implemented to support the social media strategy",
  [BlockPath.CommsBrandTaglines]:
    "Concise phrases that encapsulate the brand’s identity and value proposition",
  [BlockPath.CommsSocialCampaignChannel]:
    "Selected platforms and mediums used to execute social media marketing campaigns",
  [BlockPath.CommsSocialCampaignStrategy]:
    "Comprehensive plan outlining objectives, target audience, messaging, and execution for social campaigns",
  [BlockPath.CommsMarketingBudget]:
    "Allocated financial resources designated for marketing activities and initiatives",
  [BlockPath.CommsPaidAdvertising]:
    "Investment and approaches involving paid media placements to promote products or services",
  [BlockPath.CommsGoogleAd]:
    "Specific configurations and content details for advertisements run on Google’s advertising platform",
  [BlockPath.OperationsBusinessStaffing]:
    "Overview of personnel roles, headcount, and organizational structure supporting business operations",
  [BlockPath.OperationsOperationsLeadershipBios]:
    "Profiles summarizing the experience and qualifications of key operational leaders",
  [BlockPath.OperationsContactDetails]:
    "Essential information enabling communication with the business or its representatives",
  [BlockPath.OperationsOperationsSocialHandles]:
    "Official social media handles used by the business",
  [BlockPath.OperationsCookiePolicy]:
    "Description of rules and practices governing the use of cookies on digital platforms, including types, purposes, and user consent requirements",
  [BlockPath.OperationsPrivacyPolicy]:
    "Statement outlining how personal data is collected, used, stored, and protected, including user rights and data handling procedures",
  [BlockPath.GrowthYearGoals]:
    "List of specific, measurable objectives set to be achieved within a calendar year to guide organizational performance",
  [BlockPath.GrowthGrowthMarketingObjectives]:
    "Targets related to marketing efforts aimed at increasing customer acquisition, engagement, and revenue growth",
  [BlockPath.GrowthGrowthOkrs]:
    "Objectives and key results focused on driving business expansion and measurable progress in growth initiatives",
  [BlockPath.GrowthGrowthFiveYear]:
    "Projection or record of business growth metrics and targets spanning a five-year period",
  [BlockPath.GrowthQuarterlyPlanning]:
    "Outline of strategic goals, initiatives, and resource allocation planned for a three-month business cycle",
  [BlockPath.GrowthQuarterlyPromotion]:
    "Details of marketing and sales promotional activities scheduled or executed within a quarter",
  [BlockPath.GrowthGrowthGtmMetrics]:
    "Key performance indicators measuring the effectiveness of go-to-market strategies in driving growth",
  [BlockPath.GrowthGrowthMetrics]:
    "Quantitative measures tracking progress and success of growth-related activities and initiatives",
  [BlockPath.GrowthGrowthCampaignMetrics]:
    "Data and analytics evaluating the performance and impact of specific growth marketing campaigns",
  [BlockPath.SalesSalesObjectivesMetrics]:
    "Defined sales targets accompanied by measurable indicators to assess achievement and effectiveness",
  [BlockPath.SalesSalesCustomerProfile]:
    "The B2B/firmographic ideal customer profile — company size, industry, role of buyer, account characteristics; for organisational customers",
  [BlockPath.SalesSalesIcpTriggers]:
    "Specific events or conditions that identify ideal customer profiles and signal readiness to engage or purchase",
  [BlockPath.SalesSalesBuyerPersona]:
    'Named, individual buyer personas with their motivations, pain points, and purchase decision criteria; distinct from a general audience description by being persona-based (e.g. "Mark, the returning runner")',
  [BlockPath.SalesSalesBuyerSegments]:
    "Categorization of buyers into distinct groups based on shared characteristics relevant to sales strategies",
  [BlockPath.SalesSalesVertical]:
    "Identification and description of industry sectors or markets targeted for sales efforts",
  [BlockPath.SalesSalesPrinciples]:
    "Specific principles, rules, or methodologies the sales team follows when engaging prospects and closing deals; excludes general company values or culture",
  [BlockPath.SalesSalesProcess]:
    "Step-by-step framework outlining stages and activities involved in converting prospects into customers",
  [BlockPath.SalesOutboundEmailstrategy]:
    "Planned approach for using outbound email communications to generate leads and drive sales",
  [BlockPath.SalesOutreachSalesstrategy]:
    "Tactics and methods employed to proactively contact and engage potential customers for sales purposes",
  [BlockPath.SalesAffiliateSales]:
    "Structure and management of sales generated through third-party partners or affiliates",
  [BlockPath.SalesSalesProposalFormat]:
    "Standardized template and components used to create formal sales proposals presented to prospects",
  [BlockPath.PartnershipsMembershipPartnerships]:
    "Description of collaborative relationships involving membership benefits and mutual organizational support",
  [BlockPath.PartnershipsPartnershipsCurrent]:
    "Overview of active business partnerships including scope, objectives, and status",
  [BlockPath.PartnershipsPartnershipsAffiliate]:
    "Details of affiliate relationships focused on referral-based sales and marketing collaborations",
  [BlockPath.PolicyPolicyAi]:
    "Guidelines and rules governing the ethical use, development, and deployment of artificial intelligence technologies",
  [BlockPath.PolicyPolicyPrivacy]:
    "Formal statement detailing organizational commitments and procedures to protect individual privacy rights",
  [BlockPath.PolicyPolicyHr]:
    "Set of regulations and practices related to human resources management including hiring, conduct, and benefits",
  [BlockPath.PolicyPolicyData]:
    "Rules and standards for data management, security, access, and compliance within the organization",
  [BlockPath.PolicyPolicyBoardGovernance]:
    "Framework defining roles, responsibilities, and procedures for board of directors oversight and decision-making",
  [BlockPath.PolicyPolicyAdvocacy]:
    "Principles and procedures guiding organizational efforts to influence public policy and stakeholder opinions",
  [BlockPath.PolicyPolicyBylawsGovernance]:
    "Document specifying the internal rules and regulations that govern organizational structure and operations",
  [BlockPath.PolicyPolicyAntiBriberyCorruption]:
    "Measures and protocols established to prevent bribery, corruption, and unethical business practices",
  [BlockPath.PolicyPolicyCodeConduct]:
    "Comprehensive set of behavioral standards and ethical expectations for employees and representatives",
  [BlockPath.PolicyPolicyHsecs]:
    "Health, safety, environmental, and community standards and procedures to ensure workplace and operational compliance",
  [BlockPath.PolicyPolicyItAcceptableUsePolicy]:
    "Rules defining acceptable and prohibited uses of information technology resources within the organization",
  [BlockPath.PolicyPolicyCrimePreventionPolicy]:
    "Strategies and controls implemented to detect, prevent, and respond to criminal activities affecting the organization",
  [BlockPath.HrHrJobdescription]: "The template format of your job description",
  [BlockPath.HrHrProcess]:
    "Step-by-step description of human resources procedures, workflows, and protocols for hiring",
  [BlockPath.SustainabilitySustainabilityPolicy]:
    "Formal statement of principles, commitments, and guidelines governing an organization's approach to sustainability",
  [BlockPath.SustainabilitySustainabilityGovernance]:
    "Structure and mechanisms for oversight, accountability, and decision-making related to sustainability initiatives",
  [BlockPath.SustainabilitySustainabilityStrategicFrameworkNarrative]:
    "Description of the organization's sustainability vision, goals, and strategic approach",
  [BlockPath.SustainabilitySustainabilityStrategicFrameworkData]:
    "Quantitative and qualitative metrics supporting the sustainability strategy and its implementation",
  [BlockPath.SustainabilitySustainabilityEconomicContributionNarrative]:
    "Description of the organization's economic impact and value generated through sustainability efforts",
  [BlockPath.SustainabilitySustainabilityEconomicContributionData]:
    "Statistical and financial data illustrating the economic benefits derived from sustainability activities",
  [BlockPath.SustainabilitySustainabilityInnovationNarrative]:
    "Description of sustainability-related innovations, initiatives, and advancements within the organization",
  [BlockPath.SustainabilitySustainabilityInnovationData]:
    "Data and indicators measuring the scope and impact of sustainability innovations",
  [BlockPath.SustainabilitySustainabilityGovernanceNarrative]:
    "Description of governance practices, roles, and responsibilities in sustainability management",
  [BlockPath.SustainabilitySustainabilityGovernanceData]:
    "Data reflecting governance structures, compliance rates, and oversight effectiveness for sustainability",
  [BlockPath.SustainabilitySustainabilityComplianceNarrative]:
    "Description of adherence to sustainability-related laws, regulations, and standards",
  [BlockPath.SustainabilitySustainabilityComplianceData]:
    "Evidence and metrics demonstrating compliance status with sustainability requirements",
  [BlockPath.SustainabilitySustainabilityHumanRightsNarrative]:
    "Description of policies, commitments, and actions addressing human rights within sustainability context",
  [BlockPath.SustainabilitySustainabilityHumanRightsData]:
    "Data supporting human rights performance, incidents, and improvements related to sustainability",
  [BlockPath.SustainabilitySustainabilityRiskManagementNarrative]:
    "Description of processes and strategies for identifying, assessing, and mitigating sustainability risks",
  [BlockPath.SustainabilitySustainabilityCyberSecurityNarrative]:
    "Description of cybersecurity measures and their integration within sustainability frameworks",
  [BlockPath.SustainabilitySustainabilityCyberSecurityData]:
    "Metrics and data reflecting cybersecurity performance and risk management in sustainability context",
  [BlockPath.SustainabilitySustainabilityPeopleSocietyNarrative]:
    "Description of social sustainability initiatives impacting employees, communities, and stakeholders",
  [BlockPath.SustainabilitySustainabilityPeopleSocietyData]:
    "Quantitative and qualitative data measuring social sustainability outcomes and impacts",
  [BlockPath.SustainabilitySustainabilityHealthSafetyNarrative]:
    "Description of health and safety policies, programs, and performance related to sustainability",
  [BlockPath.SustainabilitySustainabilityHealthSafetyData]:
    "Data documenting health and safety metrics, incidents, and improvements within sustainability efforts",
  [BlockPath.SustainabilitySustainabilityWorkersNarrative]:
    "Description of workforce-related sustainability practices, rights, and engagement",
  [BlockPath.SustainabilitySustainabilityWorkersData]:
    "Data reflecting workforce demographics, conditions, and sustainability-related indicators",
  [BlockPath.SustainabilitySustainabilityCommunitiesNarrative]:
    "Description of community engagement, development, and impact as part of sustainability efforts",
  [BlockPath.SustainabilitySustainabilityCommunitiesData]:
    "Data measuring community-related sustainability initiatives and their outcomes",
  [BlockPath.SustainabilitySustainabilitySuppliersNarrative]:
    "Description of supplier sustainability policies, practices, and collaboration efforts",
  [BlockPath.SustainabilitySustainabilitySuppliersData]:
    "Data on supplier performance, compliance, and sustainability metrics",
  [BlockPath.SustainabilitySustainabilityEnvironmentNarrative]:
    "Description of environmental sustainability goals, initiatives, and impacts",
  [BlockPath.SustainabilitySustainabilityEnvironmentData]:
    "Environmental performance data including resource use, emissions, and conservation metrics",
  [BlockPath.SustainabilitySustainabilityEnvironmentalManagementNarrative]:
    "Description of systems and processes for managing environmental sustainability",
  [BlockPath.SustainabilitySustainabilityEnvironmentalManagementData]:
    "Data supporting environmental management effectiveness and compliance",
  [BlockPath.SustainabilitySustainabilityClimateChangeNarrative]:
    "Description of climate change strategies, risks, and mitigation efforts",
  [BlockPath.SustainabilitySustainabilityClimateChangeData]:
    "Data quantifying greenhouse gas emissions, reductions, and climate-related performance",
  [BlockPath.SustainabilitySustainabilityEnergyManagementNarrative]:
    "Description of energy use, efficiency initiatives, and sustainability goals",
  [BlockPath.SustainabilitySustainabilityEnergyManagementData]:
    "Data documenting energy consumption, savings, and renewable energy use",
  [BlockPath.SustainabilitySustainabilityWaterStewardshipNarrative]:
    "Description of water management policies, conservation efforts, and sustainability objectives",
  [BlockPath.SustainabilitySustainabilityWaterStewardshipData]:
    "Data measuring water use, quality, and stewardship performance",
  [BlockPath.SustainabilitySustainabilityCircularEconomyNarrative]:
    "Description of circular economy principles, practices, and sustainability integration",
  [BlockPath.SustainabilitySustainabilityCircularEconomyData]:
    "Quantitative and qualitative information on circular economy practices, metrics, and outcomes related to sustainability efforts",
  [BlockPath.SustainabilitySustainabilityTailingsNarrative]:
    "Descriptive account of tailings management approaches, challenges, and sustainability considerations",
  [BlockPath.SustainabilitySustainabilityTailingsData]:
    "Data and statistics related to tailings production, storage, environmental impact, and remediation efforts",
  [BlockPath.SustainabilitySustainabilityBiodiversityNarrative]:
    "Explanatory content on biodiversity conservation strategies, impacts, and sustainability initiatives",
  [BlockPath.SustainabilitySustainabilityBiodiversityData]:
    "Empirical data and indicators measuring biodiversity status, changes, and conservation outcomes",
  [BlockPath.SustainabilitySustainabilityStakeholderEngagementNarrative]: "",
  [BlockPath.SustainabilitySustainabilityStakeholderEngagementData]: "",
  [BlockPath.SponsorshipsSponsorshipTypes]:
    "Classification and descriptions of different categories and forms of sponsorship arrangements",
  [BlockPath.SponsorshipsSponsorshipsPackages]:
    "Details of available sponsorship packages including benefits, pricing, and deliverables",
  [BlockPath.SponsorshipsSponsorshipCurrent]:
    "Information on active sponsorship agreements, partners, and associated terms",
  [BlockPath.SponsorshipsSponsorshipCriteria]: "",
  [BlockPath.PodcastPodcastConceptPositioning]:
    "The concept for your podcast and how you want to position it in the market.",
  [BlockPath.PodcastPodcastGoalsKpis]: "The goals and KPIs for the podcast. ",
  [BlockPath.PodcastPodcastAudiencePersona]:
    "A persona of the ideal target listener to your inbox",
  [BlockPath.PodcastPodcastEpisodePlanningStrategy]:
    "A plan for upcoming episodes of the podcast",
  [BlockPath.PodcastPodcastGuestDescription]:
    "The description for the ideal type of guests who will be on the podcast",
  [BlockPath.PodcastPodcastDistributionChannels]:
    "Outline of the key distribution channels for the podcast",
  [BlockPath.PodcastPodcastBrandingGuidelines]:
    "Outline of the branding and creative guidelines for the podcast",
  [BlockPath.PodcastPodcastMonetizationSponsorship]:
    "Outline of the way the podcast is monetized and sponsored for use in any relevant communications",
  [BlockPath.GrantsGrantsMakerProfile]:
    "Background information and characteristics of organizations or entities providing grants",
  [BlockPath.GrantsGrantsImpactPortfolio]:
    "Summary of outcomes, achievements, and effects resulting from funded grants",
  [BlockPath.GrantsGrantsPrograms]:
    "Descriptions of grant programs including objectives, scope, and focus areas",
  [BlockPath.GrantsGrantsApplicationProcess]:
    "The procedures, requirements, and timelines involved in applying for grants",
  [BlockPath.GrantsGrantsTypeSize]:
    "Categorization of grants by type, size, and funding amounts available",
  [BlockPath.GrantsGrantsEligibility]:
    "Criteria and conditions determining applicant qualification for grant opportunities",
  [BlockPath.GrantsGrantsGrantees]:
    "Profiles and information about recipients of grants including demographics and project details",
  [BlockPath.GrantsGrantsLiveProposals]:
    "Current active grant proposals under consideration or review",
  [BlockPath.EventsEventsFacilities]:
    "Descriptions and specifications of venues available for events",
  [BlockPath.EventsEventsPackages]:
    "Comprehensive offerings for event organization including services, pricing, and options",
  [BlockPath.EventsEventSponsorshipsPackages]:
    "Details of sponsorship opportunities and packages specific to events",
  [BlockPath.EventsEventsFood]:
    "Information on catering options, menus, and food services for events",
  [BlockPath.EventsEventsDrinks]:
    "Details regarding beverage offerings, service types, and options for events",
  [BlockPath.EventsEventsTravel]:
    "Logistical information and arrangements related to transportation for event participants",
  [BlockPath.EventsEventsOperations]:
    "Operational aspects and management details necessary for successful event execution",
  [BlockPath.DesignerDesignerEthos]:
    "Core values, principles, and philosophy guiding the designers work and approach",
  [BlockPath.DesignerDesignerCapabilities]:
    "Range of skills, expertise, and services offered by the designer",
  [BlockPath.DesignerDesignerProcess]:
    "Structured methodology and stages followed by the designer during project execution",
  [BlockPath.DesignerDesignerProposal]:
    "Formal presentation of design concepts, plans, and deliverables for client consideration",
  [BlockPath.EducationEducationType]:
    "Classification of educational offerings by format, modality, or category",
  [BlockPath.EducationEducationStudentLevel]:
    "Hierarchy and categorization of education stages or grades provided",
  [BlockPath.EducationEducationClasses]:
    "Descriptions and details of individual courses or instructional sessions available",
  [BlockPath.EducationEducationFunding]:
    "Sources, mechanisms, and options for financing education programs and students",
  [BlockPath.EducationEducationFees]:
    "Information on costs, tuition, and charges associated with educational services",
  [BlockPath.EducationEducationFacilities]:
    "Physical infrastructure and resources supporting educational activities",
  [BlockPath.EducationEducationAlumni]:
    "Profiles and achievements of former students and graduates",
  [BlockPath.EducationEducationExtracurricular]:
    "Non-academic programs and activities offered alongside formal education",
  [BlockPath.StartupStartupProblem]:
    "Identification and description of the core issue or market gap addressed by the startup",
  [BlockPath.StartupStartupCompanyLocation]:
    "The legal and corporate structure through which the company is set up to receive investment (e.g. entity type, jurisdiction, share structure)",
  [BlockPath.StartupStartupFundraisingStatus]:
    "Current stage and progress of the startups capital raising efforts",
  [BlockPath.StartupStartupInvestorProfile]:
    "Characteristics, preferences, and background information of target investor",
  [BlockPath.StartupStartupElevatorPitch]:
    "Concise summary of the business concept, value proposition, target market, and competitive advantage",
  [BlockPath.StartupStartupInvestorUpdate]:
    "The template for periodic communication detailing company progress, key metrics, milestones achieved, challenges, and future plans for investors",
  [BlockPath.PublisherMediaPublisherMediaCitywire]: "",
  [BlockPath.PublisherMediaPublisherMediaFuture]: "",
  [BlockPath.PublisherMediaPublisherMediaIncisive]: "",
  [BlockPath.PublisherMediaPublisherMediaTrustnet]: "",
  [BlockPath.PublisherMediaPublisherMediaFtadviser]: "",
  [BlockPath.PublisherMediaPublisherMediaFinancialTimes]: "",
  [BlockPath.PublisherMediaPublisherMediaTelegraph]: "",
  [BlockPath.PublisherMediaPublisherMediaTheTimes]: "",
  [BlockPath.PublisherMediaPublisherMediaSpectator]: "",
  [BlockPath.PublisherMediaPublisherMediaNewStatesman]: "",
  [BlockPath.PublisherMediaPublisherMediaGuardian]: "",
  [BlockPath.PublisherMediaPublisherMediaObserver]: "",
  [BlockPath.PublisherMediaPublisherMediaEconomist]: "",
  [BlockPath.PublisherMediaPublisherMediaPerspectivePublishing]: "",
  [BlockPath.PublisherMediaPublisherMediaWealthWise]: "",
  [BlockPath.PublisherMediaPublisherMediaFundsEurope]: "",
  [BlockPath.PublisherMediaPublisherMediaAssetTv]: "",
  [BlockPath.PublisherMediaPublisherMediaIfaMagazine]: "",
  [BlockPath.PublisherMediaPublisherMediaPortfolioAdviser]: "",
  [BlockPath.PublisherMediaPublisherMediaMobkoi]: "",
  [BlockPath.PublisherMediaPublisherMediaSmartology]: "",
  [BlockPath.PublisherMediaPublisherMediaDianomi]: "",
  [BlockPath.PublisherMediaPublisherMediaMorningstar]: "",
  [BlockPath.PublisherMediaPublisherMediaTeads]: "",
  [BlockPath.PublisherMediaPublisherMediaSkyAdsmart]: "",
  [BlockPath.PublisherMediaPublisherMediaRadioWorks]: "",
  [BlockPath.PublisherMediaPublisherMediaQubeOoh]: "",
  [BlockPath.FarmFarmType]:
    "Classification of farm operations based on production focus, scale, and management style",
  [BlockPath.FarmFarmSize]:
    "Quantitative measurement of farm area or production capacity expressed in standard units",
  [BlockPath.FarmFarmEnvironmentalprograms]:
    "Descriptions of sustainability initiatives, conservation efforts, and regulatory compliance programs implemented on the farm",
  [BlockPath.FarmCropTypes]:
    "Varieties and categories of crops cultivated including relevant characteristics and uses",
  [BlockPath.FarmLivestockTypes]:
    "Categories and breeds of animals raised on the farm with pertinent attributes",
  [BlockPath.FarmFarmProduce]:
    "List and description of agricultural products harvested or produced including quality and quantity details",
  [BlockPath.FarmFarmEquipment]:
    "Inventory and specifications of machinery, tools, and technology used in farm operations",
  [BlockPath.FarmFarmCultivation]:
    "Methods and practices employed in planting, growing, and managing crops",
  [BlockPath.FarmFarmProcesses]:
    "Special operational workflows and procedures involved in farm management from planting to harvesting",
  [BlockPath.FarmFarmFieldKnowledge]:
    "Insights and data related to soil conditions, field history, crop rotation, and localized farming practices",
  [BlockPath.EcommEcommShipping]:
    "Details of shipping options, carriers, costs, delivery times, and policies for e-commerce orders",
  [BlockPath.EcommEcommReturnDetails]:
    "Specific conditions, procedures, and timelines governing product returns in e-commerce transactions",
  [BlockPath.EcommEcommReturns]:
    "Overview of the return process including eligibility, steps, and customer responsibilities",
  [BlockPath.EfuelsEfuelsFacilitiesOne]: "Detail your facilities ",
  [BlockPath.EfuelsEfuelsFacilitiesTwo]: "Detail your facilities ",
  [BlockPath.EfuelsEfuelsFacilitiesThree]: "Detail your facilities ",
  [BlockPath.EfuelsEfuelsFacilitiesFour]: "Detail your facilities ",
  [BlockPath.EfuelsEfuelsFacilitiesFive]: "Detail your facilities ",
  [BlockPath.EfuelsEfuelsFacilitiesSix]: "Detail your facilities ",
  [BlockPath.EfuelsEfuelsFacilitiesSeven]: "Detail your facilities ",
  [BlockPath.EfuelsEfuelsFacilitiesEight]: "Detail your facilities ",
  [BlockPath.EfuelsEfuelsFacilitiesNine]: "Detail your facilities ",
  [BlockPath.EfuelsEfuelsFacilitiesTen]: "Detail your facilities ",
  [BlockPath.EfuelsEfuelsGlobalGoals]: "",
  [BlockPath.EfuelsEfuelsDirectAirCapture]:
    "Outline your direct air capture system that takes CO2 from the atmosphere",
  [BlockPath.EfuelsEfuelsModularisation]:
    "Project to design and build HIF plants in on site and assemble in another.",
  [BlockPath.EfuelsEfuelsAdvocacy]: "",
  [BlockPath.EfuelsEfuelsInternationalPolicy]: "",
  [BlockPath.TravelTravelLocations]:
    "Descriptions and key information about destinations available for travel services",
  [BlockPath.TravelTravelAvailability]:
    "Information on dates, capacity, and booking options for travel offerings",
  [BlockPath.TravelTravelLocationtimes]:
    "Time-related details for travel destinations including time zones, best visiting periods, and seasonal considerations",
  [BlockPath.TravelTravelReseller]:
    "The approach for reselling travel products or services through affiliates",
  [BlockPath.ConsultingConsultingSpeciality]:
    "Areas of expertise and professional focus within consulting services",
  [BlockPath.ConsultingDiscoveryApproach]:
    "Structured methods and techniques used to gather client requirements and understand project scope",
  [BlockPath.ConsultingConsultingProcess]:
    "Step-by-step framework outlining phases and activities in delivering consulting engagements",
  [BlockPath.ConsultingConsultingProposal]:
    "The template for presenting project objectives, scope, methodology, timeline, and pricing for client approval",
  [BlockPath.ConsultingConsultingHourlyRate]:
    "Standardized billing rates charged per hour for consulting services including any variations",
  [BlockPath.ConsultingConsultingInterviewGuide]:
    "Structured set of questions and topics designed to facilitate client or stakeholder interviews",
  [BlockPath.ConsultingConsultingKickoffAgenda]:
    "The template for planned topics, objectives, and activities for the initial meeting to start a consulting project",
  [BlockPath.ConsultingConsultingWeeklyMeetingAgenda]:
    "The template for covering progress updates, issues, and next steps during weekly consulting engagements",
  [BlockPath.ConsultingConsultingProjectFeedbackAgenda]:
    "The template for gathering and discussing client feedback on project deliverables and performance",
  [BlockPath.ConsultingConsultingProjectStatus]:
    "The template for current state and progress indicators of a consulting engagement including milestones and risks",
  [BlockPath.ArchitectArchitectureType]:
    "Classification of architectural styles, building types, or project categories",
  [BlockPath.ArchitectArchitectureConstruction]:
    "Details related to building methods, materials, and construction processes used in architectural projects",
  [BlockPath.ArchitectArchitectureServices]:
    "Range of professional offerings provided by architects including design, planning, and consulting",
  [BlockPath.ArchitectArchitectureWork]:
    "Descriptions of completed or ongoing architectural projects including scope and outcomes",
  [BlockPath.WineWineGrapes]:
    "Varieties of grape cultivars used in wine production with characteristics and growing conditions",
  [BlockPath.WineWinePhilosophy]:
    "Core principles, values, and approaches guiding wine production and vineyard management",
  [BlockPath.WineWineVineyard]:
    "Information about vineyard location, soil, climate, and cultivation practices influencing wine quality",
  [BlockPath.WineWineTerroir]:
    "Environmental factors including soil, climate, and topography that affect the characteristics of wine",
  [BlockPath.WineWineTour]:
    "Description of organized visits focused on wine tasting and vineyard exploration including itinerary and key features",
  [BlockPath.WineRedWineList]: "",
  [BlockPath.WineWhiteWineList]: "",
  [BlockPath.WineMiscWineList]: "",
  [BlockPath.BeverageBeveragesTypes]:
    "Classification of beverages based on categories such as alcoholic, non-alcoholic, hot, and cold drinks",
  [BlockPath.BeverageBeverageVarieties]:
    "Detailed listing of different kinds or styles within each beverage type including distinguishing characteristics",
  [BlockPath.BeverageBeverageProduction]:
    "Processes and methods involved in creating beverages from raw materials to finished products",
  [BlockPath.BeverageBeverageTasting]:
    "Guidelines and criteria for evaluating the sensory attributes of beverages including flavor, aroma, and appearance",
  [BlockPath.BeverageBeveragePremises]:
    "Physical locations where beverages are produced, stored, or served including relevant facilities and equipment",
  [BlockPath.BeverageBeverageDistribution]:
    "Channels and logistics involved in delivering beverages from producers to consumers or retailers",
  [BlockPath.AccommodationAccommodationType]:
    "Categories of lodging options available such as hotels, hostels, guesthouses, and vacation rentals",
  [BlockPath.AccommodationAccommodationLocations]:
    "Geographical areas or specific sites where accommodation options are situated",
  [BlockPath.AccommodationAccommodationDescription]:
    "Detailed information about lodging features, amenities, and services offered to guests",
  [BlockPath.AccommodationAccommodationPackages]:
    "Bundled offers combining lodging with additional services or experiences for guests",
  [BlockPath.AccommodationAccommodationRules]:
    "Policies and regulations governing guest behavior, check-in/out procedures, and property use",
  [BlockPath.AccommodationAccommodationContact]:
    "Contact details and communication channels for booking and inquiries related to lodging",
  [BlockPath.SelfStorageStorageType]:
    "Classification of storage facilities based on purpose, design, or contents stored",
  [BlockPath.SelfStorageStorageArea]:
    "Physical dimensions and layout specifications of storage spaces",
  [BlockPath.SelfStorageStorageRules]:
    "Operational guidelines and restrictions for the use and management of storage facilities",
  [BlockPath.SelfStorageStorageRent]:
    "Terms, pricing, and conditions related to leasing or renting storage spaces",
  [BlockPath.SelfStorageStorageSecurity]:
    "Measures and systems implemented to protect stored items from theft, damage, or loss",
  [BlockPath.SelfStorageStorageContact]:
    "Contact information for managing or accessing storage facilities",
  [BlockPath.RestaurantRestaurantType]:
    "Categories of dining establishments based on cuisine, service style, or target clientele",
  [BlockPath.RestaurantRestaurantMenu]:
    "Comprehensive listing of food and beverage offerings available to customers",
  [BlockPath.RestaurantRestaurantSignatureDish]:
    "Distinctive or specialty dishes that represent the restaurants culinary identity",
  [BlockPath.RestaurantRestaurantPriorityDish]:
    "Highlighted menu items prioritized for promotion or customer recommendation",
  [BlockPath.RestaurantRestaurantCrossSell]:
    "Complementary food or beverage items suggested to enhance customer orders",
  [BlockPath.RestaurantRestaurantMenuPackaging]:
    "Presentation and packaging methods used for menu items, including takeout and delivery options",
  [BlockPath.RealEstateRealEstateType]:
    "Classification of properties based on usage such as residential, commercial, or industrial",
  [BlockPath.RealEstateRealEstateLocations]:
    "Geographical areas or neighborhoods where properties are situated",
  [BlockPath.RealEstateRealEstateComplaint]:
    "The process for recording grievances or issues reported by tennants",
  [BlockPath.DentistDentistTypes]:
    "Specializations and categories within dental practice such as orthodontics or periodontics",
  [BlockPath.DentistDentistTeam]:
    "Composition and roles of dental professionals working within a practice or clinic",
  [BlockPath.DoctorDoctorField]:
    "Medical specialties and areas of expertise practiced by physicians",
  [BlockPath.DoctorDoctorTeam]:
    "The group of medical professionals collaborating within a healthcare setting",
  [BlockPath.DoctorDoctorQualifications]:
    "Credentials, certifications, and educational background of medical practitioners",
  [BlockPath.DoctorDoctorInsurance]:
    "Health insurance plans accepted or covered by medical providers",
  [BlockPath.CharityNonprofitName]:
    "Categories of nonprofit organizations based on mission, activities, or legal status",
  [BlockPath.CharityNonprofitType]:
    "Categories of nonprofit organizations based on mission, activities, or legal status",
  [BlockPath.CharityNonprofitLocations]:
    "Geographical areas where nonprofit organizations operate or have presence",
  [BlockPath.CharityNonprofitFramework]:
    "Structural and governance models guiding nonprofit organization operations",
  [BlockPath.CharityNonprofitImpactModel]:
    "Approaches and strategies used by nonprofits to achieve and measure social impact",
  [BlockPath.CharityNonprofitBeneficiary]:
    "The types of aid provided to Individuals or groups receiving services or support from nonprofit organizations",
  [BlockPath.CharityNonprofitBeneficiaryGroups]:
    "Classification of beneficiary populations served by nonprofit programs",
  [BlockPath.CharityNonprofitMissionObjectives]:
    "Purpose and specific goals guiding the organization's activities and initiatives",
  [BlockPath.CharityNonprofitImpactPrograms]:
    "Programs and projects designed to achieve measurable social or community outcomes",
  [BlockPath.CharityNonprofitMetrics]:
    "Quantitative and qualitative indicators used to assess organizational performance and effectiveness",
  [BlockPath.CharityNonprofitGovernance]:
    "Structure, roles, and policies governing organizational oversight and decision-making",
  [BlockPath.CharityNonprofitPartnerships]:
    "Collaborations and alliances with other organizations or entities to advance mission goals",
  [BlockPath.CharityNonprofitFundMix]:
    "Composition and sources of financial resources supporting organizational operations",
  [BlockPath.CharityNonprofitGrants]:
    "Details of awarded funding from external sources including purpose and terms",
  [BlockPath.CharityNonprofitDonorTypes]:
    "Categories and characteristics of individuals or entities providing financial support",
  [BlockPath.CharityNonprofitTactics]:
    "Specific methods and actions employed to implement strategies and achieve objectives",
  [BlockPath.AgencyAgencyType]:
    "Classification of the agency based on services offered or industry sector",
  [BlockPath.AgencyAgencyCapabilities]:
    "Core competencies and skills that define the agency's service offerings",
  [BlockPath.AgencyAgencyProcess]:
    "Standardized workflows and procedures followed to deliver services",
  [BlockPath.AgencyAgencySpeciality]:
    "Areas of focused expertise or niche services provided by the agency",
  [BlockPath.AgencyAgencyCasestudies]:
    "Documented examples demonstrating successful project outcomes and methodologies",
  [BlockPath.AgencyAgencyAwards]:
    "Recognitions and honors received for excellence or achievements",
  [BlockPath.AgencyAgencySow]:
    "Example scope of work outlining deliverables, timelines, and responsibilities",
  [BlockPath.AgencyAgencyRates]:
    "Pricing structures and fee schedules for services rendered",
  [BlockPath.AgencyAgencyTestimonials]:
    "Client feedback and endorsements reflecting service quality and satisfaction",
  [BlockPath.AgencyAgencyLeads]:
    "Potential client contacts and opportunities for business development",
  [BlockPath.ConstructionConstructionTypes]:
    "Categories of construction projects based on purpose, scale, or methodology",
  [BlockPath.ConstructionConstructionTeam]:
    "Composition and roles of personnel involved in construction projects",
  [BlockPath.ConstructionConstructionOverhead]:
    "Fixed monthly costs associated with managing and supporting construction activities",
  [BlockPath.ConstructionConstructionOverheadVariable]:
    "Fluctuating expenses linked to construction project execution",
  [BlockPath.ConstructionConstructionBilling]:
    "A list of employees billable rates",
  [BlockPath.FundFundName]:
    "Official designation of the investment or financing fund",
  [BlockPath.FundFundSize]:
    "Total capital or assets under management within the fund",
  [BlockPath.FundFundThesis]:
    "Investment strategy and criteria guiding fund allocation decisions",
  [BlockPath.FundFundStage]:
    "Development phase or lifecycle status of the fund or its investments",
  [BlockPath.FundFundDate]: "Key dates related to fund establishment",
  [BlockPath.FundCheckSize]:
    "Typical monetary amount allocated per individual investment or grant",
  [BlockPath.FundFundProcess]:
    "Procedures and steps involved in fund management and investment decision-making",
  [BlockPath.FundFundPortfolio]:
    "The collection of assets, investments, or projects managed by the fund",
  [BlockPath.ManufacturingManufacturingIndustries]:
    "Sectors and markets served by manufacturing operations",
  [BlockPath.ManufacturingManufacturingSubsidiary]:
    "Affiliated or owned entities operating under the primary manufacturing organization",
  [BlockPath.ManufacturingManufacturingProcess]:
    "Sequence of operations and techniques used to produce goods",
  [BlockPath.ManufacturingManufacturingMaterials]:
    "Raw inputs and components utilized in production activities",
  [BlockPath.ManufacturingManufacturingSolutions]:
    "Products, services, or innovations offered to address manufacturing challenges",
  [BlockPath.CoachCoachType]:
    "Classification of coaching services based on focus area or methodology",
  [BlockPath.CoachCoachQualifications]:
    "Credentials, certifications, and experience validating coaching expertise",
  [BlockPath.CoachCoachPhilosophy]:
    "Underlying principles and approaches guiding coaching practice",
  [BlockPath.CoachCoachCourse]:
    "The structure of educational programs and curricula designed for coaching skill development including content, duration, and objectives",
  [BlockPath.CoachCoachMethod]:
    "Descriptions of systematic approaches and strategies employed by coaches to train and develop athletes or teams",
  [BlockPath.CoachCoachTechniques]:
    "Specific practical skills and procedures used by coaches during training sessions to improve performance",
  [BlockPath.CoachCoachCaseStudies]:
    "Documented examples of coaching scenarios illustrating methods, challenges, and outcomes in real-world contexts",
  [BlockPath.SportsTeamSportsTeamGround]:
    "Information about the physical location, facilities, and characteristics of the home venue used by a sports team",
  [BlockPath.SportsTeamSportsTeamCoaching]:
    "Overview of coaching staff, their roles, and coaching strategies applied within a sports team",
  [BlockPath.SportsTeamSportsTeamPlayers]:
    "Profiles and relevant details of athletes who are members of a sports team including positions and statistics",
  [BlockPath.SportsTeamSportsTeamFeatures]:
    "A list of the planned fixtures for the season",
  [BlockPath.SportsTeamSportsTeamSponsors]:
    "List and descriptions of organizations or entities providing financial or material support to a sports team",
  [BlockPath.PersonalTrainerExerciseTypes]:
    "Classification and descriptions of various forms of physical exercises categorized by purpose and method",
  [BlockPath.PersonalTrainerExerciseEquipment]:
    "Inventory and specifications of tools and devices used to perform different physical exercises",
  [BlockPath.PersonalTrainerTrainingPhilosophy]:
    "Underlying principles, beliefs, and values guiding the design and implementation of training programs",
  [BlockPath.PersonalTrainerDietPhilosophy]:
    "Core nutritional principles and approaches that inform dietary planning and recommendations",
  [BlockPath.PersonalTrainerProgramDesign]:
    "Framework and structure of training or development programs including goals, phases, and progression plans",
  [BlockPath.PersonalTrainerSuccessStories]:
    "Accounts of notable achievements and positive outcomes resulting from specific programs, coaching, or training",
  [BlockPath.GymGymOpeningTimes]:
    "Scheduled hours and days during which gym facilities are accessible to members and visitors",
  [BlockPath.GymGymEquipment]:
    "Comprehensive list and descriptions of machines, weights, and other apparatus available in a gym",
  [BlockPath.GymGymClasses]:
    "Details of organized group exercise sessions offered at a gym including types, schedules, and instructors",
  [BlockPath.AthleteAthleteSport]:
    "Identification and description of the specific sport or sports in which an athlete participates competitively",
  [BlockPath.AthleteAthleteSponsors]:
    "Entities or brands that provide financial support or endorsements to an athlete",
  [BlockPath.AthleteAthleteAchievements]:
    "Record of awards, titles, milestones, and significant accomplishments attained by an athlete",
  [BlockPath.ClimbingGymClimbingLocations]:
    "Describe the venues for climbing activities including opening times, access and environmental features",
  [BlockPath.ClimbingGymClimbingTypes]:
    "Categories and styles of climbing distinguished by technique, environment, and equipment used",
  [BlockPath.ClimbingGymClimbingEthos]:
    "Core values, cultural principles, and ethical standards upheld within the climbing community",
  [BlockPath.ClimbingGymClimbingPasses]:
    "Access permits or authorizations required for entry to climbing areas or participation in climbing events",
  [BlockPath.ClimbingGymClimbingTraining]:
    "Facilities and equipment available to enhance climbing skills, strength, and endurance",
  [BlockPath.ClimbingGymClimbingClasses]:
    "Structured instructional sessions focused on teaching climbing techniques and safety practices",
  [BlockPath.ClimbingGymClimbingSafety]:
    "Protocols, equipment standards, and best practices aimed at minimizing risks during climbing activities",
  [BlockPath.GolfClubGolfCourse]:
    "Description of the layout, features, and specifications of a golf playing area",
  [BlockPath.GolfClubGolfEthos]:
    "Fundamental principles, traditions, and sportsmanship values associated with the game of golf",
  [BlockPath.GolfClubGolfFacilities]:
    "Supporting infrastructure and amenities available at a golf venue such as clubhouses and practice areas",
  [BlockPath.GolfClubGolfCourseGuide]:
    "Comprehensive information and instructions for navigating and playing a specific golf course",
  [BlockPath.GolfClubGolfCompetitions]:
    "Details of organized golf tournaments and events including formats, participants, and schedules",
  [BlockPath.GolfClubGolfTeams]:
    "Groups of golfers organized for competitive play including team composition and roles",
  [BlockPath.LandManagementLandSize]:
    "Measurement and quantification of the area covered by a specific parcel of land",
  [BlockPath.LandManagementLandType]:
    "Classification of land based on physical characteristics such as terrain, vegetation, and usage potential",
  [BlockPath.LandManagementLandPurpose]:
    "Intended use or function designated for a parcel of land including zoning and development goals",
  [BlockPath.LandManagementLandGoals]:
    "Objectives and desired outcomes related to the management, development, or conservation of land",
  [BlockPath.LandManagementLandPolicies]:
    "Regulations, guidelines, and rules governing the use, management, and protection of land resources",
  [BlockPath.LandManagementLandRental]:
    "Terms, conditions, and arrangements related to leasing or renting land for various purposes",
  [BlockPath.LandManagementLandCapital]:
    "Description of financial resources allocated for land acquisition, development, and management including budgeting and investment details",
  [BlockPath.LandManagementLandEnvironmentalStrategy]:
    "Specification of environmental approaches and practices required to sustainably manage land resources and comply with regulations",
  [BlockPath.LandManagementLandSocial]:
    "Information on social factors and community engagement related to land use, including stakeholder relationships and social impact considerations",
  [BlockPath.LandManagementLandWildlife]:
    "Details on wildlife habitats, species protection measures, and biodiversity conservation associated with the land",
  [BlockPath.LandManagementLandTeam]:
    "Identification of personnel and organizational roles responsible for land management and related activities",
  [BlockPath.RetailRetailPrinciples]:
    "Core guidelines and foundational values that govern retail operations and decision-making processes",
  [BlockPath.RetailRetailCustomerService]:
    "Standards and procedures for delivering customer support and ensuring customer satisfaction in retail environments",
  [BlockPath.RetailRetailSeasonalCampaignBrief]:
    "Summary of objectives, target audience, key messages, and tactical plans for retail marketing campaigns aligned with seasonal periods",
  [BlockPath.RetailRetailCampaignSignOff]:
    "Documentation of approvals and authorizations required to proceed with retail marketing campaigns",
  [BlockPath.RetailRetailOpeningPlan]:
    "Detailed schedule and operational steps for launching new retail locations or reopening existing stores",
  [BlockPath.RetailRetailWholesale]:
    "Description of processes, terms, and relationships involved in selling retail products in bulk to other businesses",
  [BlockPath.RetailRetailConcessions]:
    "Agreements and operational guidelines for third-party vendors operating within retail premises",
  [BlockPath.ResearchResearchMarket]:
    "Analysis and data related to market conditions, trends, size, and competitive landscape",
  [BlockPath.ResearchResearchConsumer]:
    "Insights and information about consumer behaviors, preferences, demographics, and purchasing patterns",
  [BlockPath.ResearchResearchCompetitor]:
    "Evaluation of competitors strategies, strengths, weaknesses, and market positioning",
  [BlockPath.ResearchResearchAudienceInsights]:
    "Detailed understanding of target audience characteristics, motivations, and engagement drivers",
  [BlockPath.BuildingManagementBuildingAlterationPolicy]:
    "Rules and criteria governing modifications and structural changes to buildings",
  [BlockPath.BuildingManagementBuildingAlterationApplication]:
    "Formal request documentation for approval of proposed building alterations",
  [BlockPath.BuildingManagementBuildingSubletGuide]:
    "Instructions and requirements for subletting spaces within a building",
  [BlockPath.BuildingManagementBuildingSubletRider]:
    "Supplementary contractual provisions specific to subletting agreements",
  [BlockPath.BuildingManagementBuildingSubletApplication]:
    "Application form and supporting information required to obtain permission for subletting building space",
  [BlockPath.BuildingManagementBuildingDecorationApplication]:
    "Request and documentation process for approval of interior or exterior decoration changes",
  [BlockPath.BuildingManagementBuildingSalesPolicy]:
    "Policies and procedures regulating the sale of building units or properties",
  [BlockPath.BuildingManagementBuildingSalesApplication]:
    "Application materials and forms necessary to initiate a building sales transaction",
  [BlockPath.BuildingManagementBuildingClosingInstructions]:
    "Step-by-step guidance and requirements for completing building sale or lease closings",
  [BlockPath.BuildingManagementBuildingHowGuide]:
    "Comprehensive instructions and best practices for residing in the building",
  [BlockPath.BuildingManagementBuildingDuesPayments]:
    "Information on fees, payment schedules, and methods related to building dues and assessments",
  [BlockPath.BuildingManagementBuildingMaintenance]:
    "Plans and procedures for routine upkeep, repairs, and maintenance of building facilities",
  [BlockPath.BuildingManagementTrashManagement]:
    "Systems and protocols for waste collection, disposal, recycling, and environmental compliance",
  [BlockPath.BuildingManagementStorageWaivers]:
    "Documentation of exemptions or permissions related to storage space usage and restrictions",
  [BlockPath.BuildingManagementBuildingMovingPolicy]:
    "Regulations and procedures governing moving activities into or out of building premises",
  [BlockPath.BuildingManagementBuildingHomeowners]:
    "Details about building unit owners, their rights, responsibilities, and contact information",
  [BlockPath.BuildingManagementBuildingRefiProcess]:
    "Stepwise description of refinancing procedures applicable to building properties",
  [BlockPath.BuildingManagementBuildingRefiPolicy]:
    "Rules and eligibility criteria governing refinancing of building assets",
  [BlockPath.BuildingManagementBuildingRefiApplication]:
    "Application documentation required to initiate a building refinancing request",
  [BlockPath.BuildingManagementBuildingTrustEstate]:
    "Information on trust or estate arrangements related to building ownership or management",
  [BlockPath.BuildingManagementBuildingCertificateIncorporation]:
    "Official documentation certifying the legal incorporation status of building-related entities",
  [BlockPath.BuildingManagementBuildingDeclarationCondominium]:
    "Legal declaration outlining condominium ownership structure, rights, and obligations",
  [BlockPath.BuildingManagementBuildingOfferingPlan]:
    "Comprehensive plan detailing the terms, conditions, and disclosures for offering building units for sale",
  [BlockPath.BuildingManagementBuildingSubscriptionAgreement]:
    "Contractual agreement specifying terms for subscribing to building ownership or investment opportunities",
  [BlockPath.BuildingManagementBuildingBylaws]:
    "Regulations and rules governing the management and operation of a building, including rights and responsibilities of owners and residents",
  [BlockPath.BuildingManagementBuildingProprietaryLease]:
    "Legal document outlining the terms and conditions of ownership and occupancy rights within a building",
  [BlockPath.BuildingManagementBuildingPlans]:
    "Architectural and structural drawings detailing the design, layout, and specifications of a building",
  [BlockPath.BuildingManagementBuildingHouseRules]:
    "Set of guidelines established for the daily conduct and use of common areas within a building",
  [BlockPath.LawyerLawyerServices]:
    "Range of legal assistance and professional support provided by a lawyer to clients",
  [BlockPath.LawyerLawyerClients]:
    "Individuals or entities receiving legal representation or advice from a lawyer",
  [BlockPath.MiningMiningOperationOne]: "",
  [BlockPath.MiningMiningOperationTwo]: "",
  [BlockPath.MiningMiningOperationThree]: "",
  [BlockPath.MiningMiningOperationFour]: "",
  [BlockPath.MiningMiningOperationFive]: "",
  [BlockPath.MiningMiningOperationSix]: "",
  [BlockPath.LegacyBusinessSector]: "",
  [BlockPath.LegacyBusinessVision]: "",
  [BlockPath.LegacyProductType]: "",
  [BlockPath.LegacyAudienceLocation]: "",
  [BlockPath.LegacyAudienceAge]: "",
  [BlockPath.LegacyBrandLookAndFeel]:
    "The combined visual design and interactive behavior of a digital interface, product, or brand",
  [BlockPath.LegacyCommunityInspiration]: "",
  [BlockPath.LegacyAcquisitionBenefits]: "",
  [BlockPath.LegacyMemberBenefitsChurn]: "",
  [BlockPath.LegacyEmailTrigger]: "",
  [BlockPath.LegacyCustomerServiceApproach]: "",
  [BlockPath.LegacyLeadMagnet]: "",
  [BlockPath.LegacySearchStrategy]: "",
  [BlockPath.LegacyCompetitorSearch]: "",
  [BlockPath.LegacyOperationsFixedCosts]: "",
  [BlockPath.LegacyOpsWorkflow1]:
    "Outline a key workflow for your business that your employees will need to know",
  [BlockPath.LegacyOpsWorkflow2]:
    "Outline a key workflow for your business you will need your employees to know",
  [BlockPath.LegacyOpsWorkflow3]:
    "Outline a key workflow for your business you will need your employees to know",
  [BlockPath.LegacyCurrentSales]: "",
  [BlockPath.LegacyGrowthTurnover]: "",
  [BlockPath.LegacyStartupLocations]: "",
  [BlockPath.LegacyStartupTamSamSom]: "",
  [BlockPath.LegacyStartupCasestudy]: "",
  [BlockPath.LegacyStartupGrantAvailability]: "",
  [BlockPath.LegacyAboutPage]: "",
  [BlockPath.LegacyBusinessEcosystem]:
    "An assessment of the potential digital touch-points for your business. Assessments are not considered part of your Strategy",
  [BlockPath.LegacyCompetitiveAnalysis]: "",
  [BlockPath.LegacyCompetitiveKnown]: "",
  [BlockPath.LegacyContentEditorial]:
    "Ideas for content adjacent to your brand to drive awareness & relevance",
  [BlockPath.LegacyContentMerchandising]:
    "Content ideas that drives users to your brand with the goal to convert",
  [BlockPath.LegacyContentProduct]:
    "Outlines the key topics and headlines for content that delivers the value of your product",
  [BlockPath.LegacyContentRole]:
    "An assessment of how you could use content marketing to achieve your business goals. Assessments are not considered part of your Strategy",
  [BlockPath.LegacyEditorialCalendar]:
    "Outlines a calendar for publishing your content",
  [BlockPath.LegacyEditorialMonth]:
    "Choose a month to create an editorial calendar",
  [BlockPath.LegacyFaqPage]: "",
  [BlockPath.LegacyJobDescription]:
    "Defines a job description based on staffing recommendations",
  [BlockPath.LegacyLeadMagnetEmails]:
    "A series of welcome emails to send users who subscribe to the lead magnet",
  [BlockPath.LegacyMembershipBenefits]:
    "An expanded list of benefits at each membership tier",
  [BlockPath.LegacyMembershipPrinciples]: "",
  [BlockPath.LegacyMembershipRole]:
    "An assessment of how membership could benefit your business. Assessments are not considered part of your Strategy",
  [BlockPath.LegacyNewProduct]: "Describe a new product you need to name",
  [BlockPath.LegacyNewProductName]: "Defines a list of potential product names",
  [BlockPath.LegacyNewsletterApproach]:
    "Would you be able to develop a regular newsletter? How often is feasible?",
  [BlockPath.LegacyNoanAssessment]: "",
  [BlockPath.LegacyNoanGoals]: "",
  [BlockPath.LegacyOnboardingApproach]:
    "What do you want to learn about your customers during onboarding?",
  [BlockPath.LegacyProductAssessment]: "An assessment of your product concept",
  [BlockPath.LegacyProductConcept]:
    "Outline a product concept that you want to test against your audience segment",
  [BlockPath.LegacySectorAnalysis]: "",
  [BlockPath.LegacyStaffBudget]:
    "How many new roles do you have the budget for?",
  [BlockPath.LegacyStaffingRecommendation]:
    "Outlines a recommendation for new staff to deliver on your business goals",
  [BlockPath.LegacyStartupPitchDeck]: "",
  [BlockPath.LegacyUserResearch]:
    "Outline a concept from your strategy or an idea that you want to test with synthetic users across all your audience segments",
  [BlockPath.LegacyUserResearchFeedback]:
    "Outlines feedback from synthetic users on your concept",
  [BlockPath.LegacyWebsiteHomepage]:
    "An overview of the homepage structure and copy for your website",
  [BlockPath.LegacyWebsiteNavigation]:
    "An outline of the structure of your website",
  [BlockPath.LegacyWhitespace]: "",
} as const;
